(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fp-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fp-announcement]').forEach(function (bar) {
      var duracionHoras = parseFloat(bar.getAttribute('data-duracion-horas')) || 48;
      var reiniciar = bar.getAttribute('data-reiniciar') === 'true';
      var segundosPorMensaje = parseFloat(bar.getAttribute('data-segundos')) || 4;
      var storageKey = 'fp_announcement_expires_' + duracionHoras + '_' + reiniciar;

      function alturaSlide() {
        var raw = getComputedStyle(bar).getPropertyValue('--fp-slide-h').trim();
        var n = parseFloat(raw);
        if (isNaN(n) || n <= 0) return 30;
        return n;
      }

      function obtenerExpiracion() {
        var guardado = null;
        try { guardado = localStorage.getItem(storageKey); } catch (e) {}
        var expira = guardado ? parseInt(guardado, 10) : null;
        if (!expira) {
          expira = Date.now() + duracionHoras * 60 * 60 * 1000;
          try { localStorage.setItem(storageKey, expira); } catch (e) {}
        }
        return expira;
      }

      var expira = obtenerExpiracion();

      function pad(n) {
        n = Math.max(0, n);
        return String(n).length < 2 ? '0' + n : String(n);
      }

      function actualizarTimers() {
        var restante = expira - Date.now();
        if (restante <= 0) {
          if (reiniciar) {
            expira = Date.now() + duracionHoras * 60 * 60 * 1000;
            try { localStorage.setItem(storageKey, expira); } catch (e) {}
            restante = expira - Date.now();
          } else {
            restante = 0;
          }
        }
        var totalSegundos = Math.floor(restante / 1000);
        var dias = Math.floor(totalSegundos / 86400);
        var horas = Math.floor((totalSegundos % 86400) / 3600);
        var minutos = Math.floor((totalSegundos % 3600) / 60);
        var segundos = totalSegundos % 60;
        bar.querySelectorAll('[data-fp-dias]').forEach(function (el) { el.textContent = pad(dias); });
        bar.querySelectorAll('[data-fp-horas]').forEach(function (el) { el.textContent = pad(horas); });
        bar.querySelectorAll('[data-fp-minutos]').forEach(function (el) { el.textContent = pad(minutos); });
        bar.querySelectorAll('[data-fp-segundos]').forEach(function (el) { el.textContent = pad(segundos); });
      }

      actualizarTimers();
      setInterval(actualizarTimers, 1000);

      var pista = bar.querySelector('[data-fp-ann-pista]');
      var slidesReales = bar.querySelectorAll('.fp-announcement__slide:not([data-fp-ann-clon])');
      var hayClon = !!bar.querySelector('[data-fp-ann-clon]');
      var totalConClon = pista ? pista.querySelectorAll('.fp-announcement__slide').length : 0;
      var botonPrev = bar.querySelector('[data-fp-ann-prev]');
      var botonNext = bar.querySelector('[data-fp-ann-next]');
      if (!pista || slidesReales.length <= 1) return;

      var indice = 0;
      var temporizador = null;
      var enTransicionDeReset = false;

      function fijarSinTransicion(nuevoIndice) {
        pista.style.transition = 'none';
        pista.style.transform = 'translateY(-' + (nuevoIndice * alturaSlide()) + 'px)';
        pista.getBoundingClientRect();
        pista.style.transition = '';
      }

      function siguiente() {
        if (enTransicionDeReset) return;
        indice = indice + 1;
        pista.style.transform = 'translateY(-' + (indice * alturaSlide()) + 'px)';
        if (hayClon && indice === totalConClon - 1) {
          enTransicionDeReset = true;
          setTimeout(function () {
            indice = 0;
            fijarSinTransicion(0);
            enTransicionDeReset = false;
          }, 520);
        }
      }

      function anterior() {
        if (enTransicionDeReset) return;
        if (indice === 0) {
          enTransicionDeReset = true;
          fijarSinTransicion(hayClon ? totalConClon - 1 : slidesReales.length - 1);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              indice = slidesReales.length - 1;
              pista.style.transform = 'translateY(-' + (indice * alturaSlide()) + 'px)';
              enTransicionDeReset = false;
            });
          });
          return;
        }
        indice = indice - 1;
        pista.style.transform = 'translateY(-' + (indice * alturaSlide()) + 'px)';
      }

      function iniciarRotacion() {
        if (temporizador) clearInterval(temporizador);
        temporizador = setInterval(siguiente, segundosPorMensaje * 1000);
      }

      function reiniciarRotacion() { iniciarRotacion(); }

      if (botonNext) {
        botonNext.addEventListener('click', function () { siguiente(); reiniciarRotacion(); });
      }
      if (botonPrev) {
        botonPrev.addEventListener('click', function () { anterior(); reiniciarRotacion(); });
      }

      window.addEventListener('resize', function () { fijarSinTransicion(indice); });

      iniciarRotacion();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-as-seen-on"] && !Shopify.designMode) return;
  try {
    
(function () {
  function esMovil() { return window.matchMedia('(max-width: 749px)').matches; }

  function centrarMedio(grid) {
    if (!esMovil()) return;
    var tarjetas = grid.querySelectorAll('.fp-aso__card');
    if (!tarjetas.length) return;
    var idxMedio = Math.floor(tarjetas.length / 2);
    var mid = tarjetas[idxMedio];
    if (!mid) return;
    grid.classList.add('fp-aso__grid--sin-snap');
    var gridRect = grid.getBoundingClientRect();
    var midRect = mid.getBoundingClientRect();
    var offset = (midRect.left + midRect.width / 2) - (gridRect.left + gridRect.width / 2);
    grid.scrollLeft = grid.scrollLeft + offset;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        grid.classList.remove('fp-aso__grid--sin-snap');
      });
    });
  }

  function esperarImagenes(root, cb) {
    var imgs = root.querySelectorAll('.fp-aso__img');
    if (!imgs.length) { cb(); return; }
    var pendientes = 0;
    imgs.forEach(function (img) {
      if (img.tagName === 'IMG' && !img.complete) {
        pendientes++;
        img.addEventListener('load', function () { if (--pendientes <= 0) cb(); }, { once: true });
        img.addEventListener('error', function () { if (--pendientes <= 0) cb(); }, { once: true });
      }
    });
    if (pendientes === 0) cb();
  }

  function actualizarScrollbar(grid, thumb) {
    var scrollMax = grid.scrollWidth - grid.clientWidth;
    var scroll = grid.scrollLeft;
    if (scrollMax <= 0) return;
    var thumbAncho = Math.max(20, (grid.clientWidth / grid.scrollWidth) * 100);
    var thumbPos = (scroll / scrollMax) * (100 - thumbAncho);
    thumb.style.width = thumbAncho + '%';
    thumb.style.left = thumbPos + '%';
  }

  document.querySelectorAll('[data-fp-aso]').forEach(function (root) {
    var grid = root.querySelector('[data-fp-aso-grid]');
    var thumb = root.querySelector('[data-fp-aso-scrollbar-thumb]');
    if (!grid) return;

    var yaCentrado = false;
    function intentarCentrar() {
      if (!esMovil()) return;
      esperarImagenes(root, function () {
        centrarMedio(grid);
        yaCentrado = true;
        if (thumb) actualizarScrollbar(grid, thumb);
      });
    }

    // Intentos multiples para pillar todos los momentos de layout
    setTimeout(intentarCentrar, 0);
    setTimeout(intentarCentrar, 200);
    setTimeout(intentarCentrar, 800);
    window.addEventListener('load', intentarCentrar);

    // Cuando la seccion entra en viewport, forzar centrado
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            intentarCentrar();
          }
        });
      }, { rootMargin: '0px 0px -30% 0px', threshold: 0 });
      io.observe(root);
    }

    if (thumb) {
      grid.addEventListener('scroll', function () { actualizarScrollbar(grid, thumb); }, { passive: true });
      window.addEventListener('resize', function () { actualizarScrollbar(grid, thumb); yaCentrado = false; intentarCentrar(); });
    }

    var esTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    if (esTouch) {
      var tarjetas = root.querySelectorAll('[data-fp-aso-card]');
      tarjetas.forEach(function (tarjeta) {
        tarjeta.addEventListener('click', function (e) {
          if (!tarjeta.classList.contains('is-active')) {
            e.preventDefault();
            tarjetas.forEach(function (t) { if (t !== tarjeta) t.classList.remove('is-active'); });
            tarjeta.classList.add('is-active');
          }
        });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-fp-aso-card]')) {
          tarjetas.forEach(function (t) { t.classList.remove('is-active'); });
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-brand-phrase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fpAjustarFraseDeMarca() {
      document.querySelectorAll('.fp-brand-phrase').forEach(function (raiz) {
        var contenedor = raiz.querySelector('[data-fp-brand-phrase-contenedor]');
        var texto = raiz.querySelector('[data-fp-brand-phrase-texto]');
        if (!contenedor || !texto) return;
        if (window.innerWidth <= 989) { texto.style.fontSize = ''; return; }
        var escala = parseFloat(raiz.getAttribute('data-fp-brand-escala')) || 98;
        escala = escala / 100;
        texto.style.fontSize = '100px';
        var anchoTexto = texto.getBoundingClientRect().width;
        var anchoDisponible = contenedor.getBoundingClientRect().width;
        if (!anchoTexto || !anchoDisponible) return;
        var nuevoTamano = (anchoDisponible / anchoTexto) * 100 * escala;
        texto.style.fontSize = nuevoTamano + 'px';
      });
    }
    fpAjustarFraseDeMarca();
    window.addEventListener('load', fpAjustarFraseDeMarca);
    window.addEventListener('resize', fpAjustarFraseDeMarca);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fpAjustarFraseDeMarca); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-collection-header"] && !Shopify.designMode) return;
  try {
    
  /* (28/09) Carrusel movil de la cabecera de coleccion: mismo efecto y tiempos que el hero de la home
     (sale en 0,2 s; entra en 0,8 s con zoom 1,2 -> 1; puntos con contador; deslizar con el dedo). */
  (function () {
    var EASE_SALIDA = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
    var EASE_ENTRADA = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    var mq = window.matchMedia('(max-width: 749px)');
    function iniciar(raiz) {
      if (raiz.dataset.fpCcListo) return;
      raiz.dataset.fpCcListo = '1';
      var slides = Array.prototype.slice.call(raiz.querySelectorAll('.fp-cc__slide'));
      if (slides.length < 2) return;
      var puntos = Array.prototype.slice.call(raiz.querySelectorAll('.fp-cc__dot'));
      var boton = raiz.querySelector('[data-fp-cc-boton]');
      var enlaces = [raiz.getAttribute('data-enlace-1'), raiz.getAttribute('data-enlace-2')];
      var seg = parseFloat(raiz.getAttribute('data-segundos')) || 3;
      var st = { i: 0, timer: null, ocupado: false };
      slides.forEach(function (sl) { var im = sl.querySelector('img'); if (im && mq.matches) im.loading = 'eager'; });
      function marcar(i) { puntos.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
      function reiniciar() { var b = puntos[st.i]; if (!b) return; b.setAttribute('aria-current', 'false'); void b.offsetWidth; b.setAttribute('aria-current', 'true'); }
      function programar() {
        clearTimeout(st.timer);
        st.timer = setTimeout(function () { if (!mq.matches) { programar(); return; } ir(1, false); }, seg * 1000);
      }
      function ir(paso, manual) {
        if (st.ocupado) { if (!manual) { clearTimeout(st.timer); st.timer = setTimeout(function () { ir(paso, false); }, 300); } return; }
        var n = slides.length, desde = slides[st.i], nuevo = (st.i + paso + n) % n, hacia = slides[nuevo];
        st.ocupado = true;
        clearTimeout(st.timer);
        var salida = desde.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: EASE_SALIDA, fill: 'both' });
        setTimeout(function () {
          desde.classList.remove('is-selected'); desde.setAttribute('aria-hidden', 'true');
          hacia.classList.add('is-selected'); hacia.removeAttribute('aria-hidden');
          salida.cancel();
          st.i = nuevo;
          marcar(nuevo);
          programar();
          if (boton) boton.href = enlaces[nuevo] || enlaces[0];
          var entrada = hacia.animate([{ opacity: 0, transform: 'scale(1.2)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 800, easing: EASE_ENTRADA, fill: 'both' });
          setTimeout(function () { entrada.cancel(); st.ocupado = false; }, 820);
        }, 210);
      }
      puntos.forEach(function (b, i) {
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (i === st.i) return; ir(i - st.i, true); });
      });
      var zona = raiz.querySelector('.fp-cc__movil'), x0 = null, y0 = null;
      zona.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      zona.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) ir(dx < 0 ? 1 : -1, true);
      }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(st.timer); else { reiniciar(); programar(); } });
      mq.addEventListener('change', function () { if (mq.matches) { slides.forEach(function (sl) { var im = sl.querySelector('img'); if (im) im.loading = 'eager'; }); reiniciar(); programar(); } });
      programar();
    }
    function todos() { document.querySelectorAll('[data-fp-cc]').forEach(iniciar); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
    document.addEventListener('shopify:section:load', todos);
  })();

  /* (29/09) Barra movil Filtrar | Ordenar por */
  (function () {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-fp-coll-filtrar]');
      if (!b) return;
      e.preventDefault();
      var t = document.querySelector('.facets-toggle__button');
      if (t) t.click();
    });
    document.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('[data-fp-coll-orden]');
      if (!s) return;
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  })();

  (function () {
    function fpEsFiltroAOcultar(txt) {
      if (!txt) return false;
      var t = txt.trim().toLowerCase();
      return t === 'disponibilidad' || t === 'precio';
    }
    function fpMarcarFiltros() {
      var candidatos = document.querySelectorAll('.facets details, .facets__item, .facets-container details, .facets-form details, filter-block, [data-filter]');
      candidatos.forEach(function (nodo) {
        if (nodo.dataset.fpHideFilterChecked === '1') return;
        var textoResumen = '';
        var summary = nodo.querySelector('summary, .facets__summary, .facets__label, .facets-block__header, [class*="filter"] button, legend');
        if (summary) textoResumen = summary.textContent || '';
        if (!textoResumen && nodo.getAttribute) textoResumen = nodo.getAttribute('data-filter') || '';
        if (fpEsFiltroAOcultar(textoResumen)) { nodo.setAttribute('data-fp-hide-filter', 'true'); }
        nodo.dataset.fpHideFilterChecked = '1';
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fpMarcarFiltros); } else { fpMarcarFiltros(); }
    var mo = new MutationObserver(function () { fpMarcarFiltros(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-diag-temporal"]) return;
  try {
    
  (function () {
    var caja = document.querySelector('[data-fp-diag]');
    if (!caja) return;
    function actualizar() {
      caja.textContent = 'DIAG innerWidth=' + window.innerWidth + ' movil=' + (window.innerWidth <= 989);
    }
    actualizar();
    window.addEventListener('resize', actualizar);
    setInterval(actualizar, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fpActualizarHeaderFijo() {
      document.querySelectorAll('[data-fp-header]').forEach(function (header) {
        var espaciador = header.previousElementSibling;
        var esFijo = header.classList.contains('fp-header--sticky');
        if (espaciador && espaciador.hasAttribute('data-fp-header-spacer')) {
          espaciador.style.height = header.offsetHeight + 'px';
        }
        if (esFijo) {
          var anuncio = document.querySelector('.fp-announcement');
          var desplazamientoSuperior = 0;
          if (anuncio) {
            var limites = anuncio.getBoundingClientRect();
            desplazamientoSuperior = Math.max(0, limites.bottom);
          }
          header.style.top = desplazamientoSuperior + 'px';
          document.documentElement.style.setProperty('--sticky-header-offset', (desplazamientoSuperior + header.offsetHeight) + 'px');
        } else {
          document.documentElement.style.setProperty('--sticky-header-offset', '0px');
        }
      });
    }
    fpActualizarHeaderFijo();
    window.addEventListener('resize', fpActualizarHeaderFijo);
    window.addEventListener('load', fpActualizarHeaderFijo);
    window.addEventListener('scroll', fpActualizarHeaderFijo, { passive: true });

    function fpInicializarMegaMenuHover() {
      var elementosConMenu = document.querySelectorAll('.fp-header__nav-item--con-menu');
      elementosConMenu.forEach(function (item) {
        if (item.dataset.fpMegaListo) return;
        item.dataset.fpMegaListo = 'true';
        var temporizadorCierre = null;
        item.addEventListener('mouseenter', function () {
          if (temporizadorCierre) { clearTimeout(temporizadorCierre); temporizadorCierre = null; }
          item.classList.add('fp-header__nav-item--open');
        });
        item.addEventListener('mouseleave', function () {
          temporizadorCierre = setTimeout(function () { item.classList.remove('fp-header__nav-item--open'); }, 250);
        });
      });
    }
    fpInicializarMegaMenuHover();
    setInterval(fpInicializarMegaMenuHover, 2000);

    document.addEventListener('click', function (e) {
      var abrirBtn = e.target.closest && e.target.closest('[data-fp-burger-abrir]');
      var cerrarBtn = e.target.closest && e.target.closest('[data-fp-mobile-menu-cerrar]');
      var overlay = e.target.closest && e.target.closest('[data-fp-mobile-menu-overlay]');
      var menu = document.querySelector('[data-fp-mobile-menu]');
      if (!menu) return;
      if (abrirBtn) {
        menu.classList.add('fp-mobile-menu--abierto');
        menu.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      } else if (cerrarBtn || overlay) {
        menu.classList.remove('fp-mobile-menu--abierto');
        menu.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      }
    });

    var FPWishlist = (function () {
      var CLAVE = 'fp_wishlist';
      function obtener() {
        try {
          var datos = JSON.parse(localStorage.getItem(CLAVE) || '[]');
          return Array.isArray(datos) ? datos : [];
        } catch (e) { return []; }
      }
      function guardar(lista) {
        try { localStorage.setItem(CLAVE, JSON.stringify(lista)); } catch (e) {}
        actualizarContadores();
        document.dispatchEvent(new CustomEvent('fp:wishlist-cambiada', { detail: { lista: lista } }));
      }
      function tiene(handle) { return obtener().indexOf(handle) !== -1; }
      function alternar(handle) {
        var lista = obtener();
        var idx = lista.indexOf(handle);
        if (idx === -1) { lista.push(handle); } else { lista.splice(idx, 1); }
        guardar(lista);
        return tiene(handle);
      }
      function quitar(handle) {
        guardar(obtener().filter(function (h) { return h !== handle; }));
      }
      function actualizarContadores() {
        var cantidad = obtener().length;
        document.querySelectorAll('[data-fp-wishlist-count]').forEach(function (el) {
          if (el.textContent !== String(cantidad)) el.textContent = cantidad;
          if (el.hidden !== (cantidad === 0)) el.hidden = cantidad === 0;
        });
      }
      function init() { actualizarContadores(); }
      return { getAll: obtener, toggle: alternar, isSaved: tiene, quitar: quitar, init: init };
    })();
    window.FPWishlist = FPWishlist;
    FPWishlist.init();
    setInterval(function () { FPWishlist.init(); }, 2000);

    /* ============ FP BUSCADOR EN VIVO ============ */
    var FPSearch = (function () {
      var indice = [];
      var el = {};

      function cargarIndice() {
        var nodo = document.getElementById('fp-search-index');
        if (!nodo) return [];
        try { return JSON.parse(nodo.textContent || '[]'); } catch (e) { return []; }
      }

      /* (09/10) Si el indice de la pagina viene incompleto (p. ej. en una URL con ?page=2),
         se pide la seccion renderizada desde la portada, que trae el indice entero. */
      var indiceCompletando = false;
      function completarIndice() {
        var nodo = document.getElementById('fp-search-index');
        if (!nodo || indiceCompletando) return;
        var total = parseInt(nodo.getAttribute('data-total') || '0', 10);
        var seccion = nodo.getAttribute('data-seccion');
        if (!seccion || !total || indice.length >= total) return;
        indiceCompletando = true;
        fetch('/?sections=' + encodeURIComponent(seccion), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (datos) {
            var html = datos && datos[seccion];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var n2 = doc.getElementById('fp-search-index');
            if (!n2) return;
            var nuevo = JSON.parse(n2.textContent || '[]');
            if (nuevo.length > indice.length) {
              indice = nuevo;
              if (el.input && el.input.value) buscar(el.input.value);
            }
          })
          .catch(function () {})
          .then(function () { indiceCompletando = false; });
      }

      function normalizar(texto) {
        return (texto || '')
          .toString()
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .toLowerCase()
          .trim();
      }

      function formatearPrecio(centimos) {
        return (centimos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
      }

      function refrescarReferencias() {
        el.overlay = document.querySelector('[data-fp-search-overlay]');
        el.input = document.querySelector('[data-fp-search-input]');
        el.sugerencias = document.querySelector('[data-fp-search-sugerencias]');
        el.resultados = document.querySelector('[data-fp-search-resultados]');
        el.grid = document.querySelector('[data-fp-search-grid]');
        el.vacio = document.querySelector('[data-fp-search-vacio]');
      }

      function abrir() {
        refrescarReferencias();
        if (!el.overlay) return;
        el.overlay.classList.add('fp-search--abierto');
        el.overlay.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        setTimeout(function () { if (el.input) el.input.focus(); }, 150);
      }

      function cerrar() {
        refrescarReferencias();
        if (!el.overlay) return;
        el.overlay.classList.remove('fp-search--abierto');
        el.overlay.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      }

      function pintarTarjeta(producto) {
        var precioActual = producto.price || 0;
        var compareAt = producto.compareAt || 0;
        var preciosHtml = '<span class="fp-search-item__precio-actual">' + formatearPrecio(precioActual) + '</span>';
        var badgeHtml = '';
        if (compareAt && compareAt > precioActual) {
          var porcentaje = Math.round(((compareAt - precioActual) / compareAt) * 100);
          preciosHtml += '<span class="fp-search-item__precio-tachado">' + formatearPrecio(compareAt) + '</span>';
          preciosHtml += '<span class="fp-search-item__descuento">-' + porcentaje + '%</span>';
          badgeHtml = '<span class="fp-search-item__badge">Oferta</span>';
        }
        var editorialHtml = producto.editorial ? '<p class="fp-search-item__editorial">' + producto.editorial + '</p>' : '';
        return (
          '<a href="' + producto.url + '" class="fp-search-item">' +
          '<div class="fp-search-item__imagen">' + badgeHtml + (producto.image ? '<img src="' + producto.image + '" alt="" loading="lazy">' : '') + '</div>' +
          editorialHtml +
          '<p class="fp-search-item__titulo">' + producto.title + '</p>' +
          '<div class="fp-search-item__precios">' + preciosHtml + '</div>' +
          '</a>'
        );
      }

      function buscar(consulta) {
        refrescarReferencias();
        var q = normalizar(consulta);

        if (!q) {
          if (el.sugerencias) el.sugerencias.hidden = false;
          if (el.resultados) el.resultados.hidden = true;
          if (el.vacio) el.vacio.hidden = true;
          return;
        }

        if (el.sugerencias) el.sugerencias.hidden = true;

        /* (09/10) Cada palabra escrita tiene que aparecer en el nombre, el nombre editorial o el tipo
           (en cualquier orden). Se muestran todos los resultados, no solo 8. */
        var palabras = q.split(/\s+/).filter(Boolean);
        var coincidencias = indice.filter(function (p) {
          var texto = normalizar(p.title) + ' ' + normalizar(p.editorial) + ' ' + normalizar(p.tipo);
          return palabras.every(function (w) { return texto.indexOf(w) !== -1; });
        }).slice(0, 80);

        if (coincidencias.length === 0) {
          if (el.resultados) el.resultados.hidden = true;
          if (el.vacio) el.vacio.hidden = false;
          return;
        }

        if (el.vacio) el.vacio.hidden = true;
        if (el.resultados) el.resultados.hidden = false;
        if (el.grid) el.grid.innerHTML = coincidencias.map(pintarTarjeta).join('');
      }

      function init() {
        indice = cargarIndice();
        refrescarReferencias();
        completarIndice();

        document.addEventListener('click', function (e) {
          var abrirBtn = e.target.closest && e.target.closest('[data-fp-search-abrir]');
          var cerrarBtn = e.target.closest && e.target.closest('[data-fp-search-cerrar]');
          var fondoBtn = e.target.closest && e.target.closest('[data-fp-search-cerrar-fondo]');
          var sugerenciaBtn = e.target.closest && e.target.closest('[data-fp-search-sugerencia]');

          if (abrirBtn) { e.preventDefault(); abrir(); }
          else if (cerrarBtn || fondoBtn) { cerrar(); }
          else if (sugerenciaBtn && el.input) {
            el.input.value = sugerenciaBtn.textContent.trim();
            buscar(el.input.value);
            el.input.focus();
          }
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') cerrar();
        });

        document.addEventListener('input', function (e) {
          if (e.target && e.target.matches('[data-fp-search-input]')) {
            buscar(e.target.value);
          }
        });
      }

      return { init: init };
    })();
    FPSearch.init();

    var FPCart = (function () {
      var el = {};
      var estado = null;
      var cacheProductos = {};
      var UMBRAL_ENVIO_GRATIS = 20000;
      var ultimoProductIdUpsell = null;
      var fpScrollY = 0;

      function refrescarReferencias() {
        el.drawer = document.querySelector('[data-fp-cart-drawer]');
        el.overlay = document.querySelector('[data-fp-cart-overlay]');
        el.lista = document.querySelector('[data-fp-cart-lista]');
        el.vacio = document.querySelector('[data-fp-cart-vacio]');
        el.footer = document.querySelector('[data-fp-cart-footer]');
        el.total = document.querySelector('[data-fp-cart-total]');
        el.codigos = document.querySelector('[data-fp-cart-codigos]');
        el.paris5 = document.querySelector('[data-fp-cart-paris5]');
        el.cw = document.querySelector('[data-fp-cw]');
        el.contadores = document.querySelectorAll('[data-fp-cart-count], [data-fp-cart-count-panel]');
        el.envioCaja = document.querySelector('[data-fp-cart-envio]');
        el.envioTexto = document.querySelector('[data-fp-cart-envio-texto]');
        el.envioProgreso = document.querySelector('[data-fp-cart-envio-progreso]');
        el.upsellCaja = document.querySelector('[data-fp-cart-upsell]');
        el.upsellLista = document.querySelector('[data-fp-cart-upsell-lista]');
      }

      function init() {
        refrescarReferencias();
        if (!el.drawer) return;

        document.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-fp-cart-cerrar]')) cerrar();
          if (e.target.closest && e.target.closest('[data-fp-cart-overlay]')) cerrar();
          var abrirBtn = e.target.closest && e.target.closest('[data-fp-cart-abrir]');
          if (abrirBtn) { e.preventDefault(); abrir(); }
          var prevBtn = e.target.closest && e.target.closest('[data-fp-cart-upsell-prev]');
          if (prevBtn && el.upsellLista) el.upsellLista.scrollBy({ left: -(el.upsellLista.clientWidth + 12), behavior: 'smooth' });
          var nextBtn = e.target.closest && e.target.closest('[data-fp-cart-upsell-next]');
          if (nextBtn && el.upsellLista) el.upsellLista.scrollBy({ left: el.upsellLista.clientWidth + 12, behavior: 'smooth' });
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });


        document.addEventListener('change', function (e) {
          var toggle = e.target;
          if (!toggle.matches('[data-fp-service-toggle]')) return;
          var error = document.querySelector('[data-fp-service-error]');
          var desired = toggle.checked;
          toggle.disabled = true;
          error.hidden = true;
          cargar().then(function (c) {
            var item = c.items.find(function (i) { return String(i.variant_id) === toggle.dataset.variant; });
            if (desired && item || !desired && !item) return;
            return fetch(desired ? '/cart/add.js' : '/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(desired ? { id: toggle.dataset.variant, quantity: 1 } : { id: item.key, quantity: 0 })
            }).then(function (r) { if (!r.ok) throw new Error('service'); });
          }).then(cargar).catch(function () {
            error.textContent = 'No hemos podido actualizar el servicio. Vuelve a intentarlo.';
            error.hidden = false;
            return cargar();
          }).finally(function () { toggle.disabled = false; });
        });
        iniciarCw();
        cargar();
        interceptarAddToCart();
      }

      function abrir() {
        refrescarReferencias();
        if (!el.drawer) return;
        var yaAbierta = el.drawer.classList.contains('fp-cart--abierto');
        el.drawer.classList.add('fp-cart--abierto');
        el.drawer.setAttribute('aria-hidden', 'false');
        /* Bloqueo robusto del scroll de fondo (iOS Safari no respeta overflow:hidden
           por sí solo con touch/rubber-band; esto provocaba un hueco en blanco
           "clicable" que abría un producto invisible al hacer scroll en el carrusel
           de recomendaciones del carrito en móvil).
           FP 10/10/2026: si la cesta ya estaba abierta no se repite (se perdía la posición de la página). */
        if (!yaAbierta) {
          fpScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
          document.documentElement.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
          document.body.style.top = (-fpScrollY) + 'px';
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.width = '100%';
        }
        cargar();
      }

      function cerrar() {
        refrescarReferencias();
        if (!el.drawer) return;
        el.drawer.classList.remove('fp-cart--abierto');
        el.drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, fpScrollY || 0);
      }

      function formatear(centimos) {
        return (centimos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
      }

      function escapar(texto) {
        var d = document.createElement('div');
        d.textContent = texto || '';
        return d.innerHTML;
      }

      function imagenPequena(url, ancho) {
        if (!url) return '';
        return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_' + (ancho || 240) + 'x$1$2');
      }

      function cargar() {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { estado = c; renderizar(c); return c; });
      }

      function obtenerCompareAt(item) {
        if (!item.handle) return Promise.resolve(null);
        var promesa = cacheProductos[item.handle];
        if (!promesa) {
          promesa = fetch('/products/' + item.handle + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
          cacheProductos[item.handle] = promesa;
        }
        return promesa.then(function (producto) {
          if (!producto || !producto.variants) return null;
          var variante = producto.variants.filter(function (v) { return v.id === item.variant_id; })[0];
          return variante ? variante.compare_at_price : null;
        });
      }

      function actualizarBarraEnvio(subtotal) {
        if (!el.envioCaja) return;
        el.envioCaja.hidden = false;
        var restante = UMBRAL_ENVIO_GRATIS - subtotal;
        var porcentaje = Math.min(100, Math.max(0, Math.round((subtotal / UMBRAL_ENVIO_GRATIS) * 100)));
        if (el.envioProgreso) el.envioProgreso.style.width = porcentaje + '%';
        el.envioCaja.classList.toggle('fp-cart__envio--completo', restante <= 0);
        if (el.envioTexto) {
          var txtOk = el.envioCaja.getAttribute('data-txt-completo') || 'Envío gratis desbloqueado';
          var txtFalta = el.envioCaja.getAttribute('data-txt-falta') || 'A solo [importe] del envío gratuito';
          if (restante <= 0) { el.envioTexto.textContent = txtOk; }
          else { el.envioTexto.innerHTML = escapar(txtFalta).replace('[importe]', '<strong>' + formatear(restante) + '</strong>'); }
        }
      }

      var ICONO_ETIQUETA = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round" aria-hidden="true"><path d="M6.6 1.2h4.2v4.2L5.7 10.5a.9.9 0 0 1-1.3 0L1.5 7.6a.9.9 0 0 1 0-1.3z"/><circle cx="8.7" cy="3.3" r=".8"/></svg>';
      var ICONO_MENOS = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.1" aria-hidden="true"><path d="M1 6h10"/></svg>';
      var ICONO_MAS = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.1" aria-hidden="true"><path d="M1 6h10M6 1v10"/></svg>';

      /* FP 10/10/2026: códigos de descuento aplicables de la cesta y lo que descuenta cada uno (en céntimos). */
      function codigosAplicados(c) {
        var lista = [];
        ((c && c.discount_codes) || []).forEach(function (d) {
          if (!d || !d.applicable || !d.code) return;
          var codigo = String(d.code);
          var clave = codigo.toUpperCase();
          var importe = 0;
          (c.cart_level_discount_applications || []).forEach(function (a) {
            if (a && a.type === 'discount_code' && String(a.title || '').toUpperCase() === clave) importe += a.total_allocated_amount || 0;
          });
          (c.items || []).forEach(function (it) {
            (it.line_level_discount_allocations || []).forEach(function (al) {
              var ap = al && al.discount_application;
              if (ap && ap.type === 'discount_code' && String(ap.title || '').toUpperCase() === clave) importe += al.amount || 0;
            });
          });
          lista.push({ codigo: codigo, importe: importe });
        });
        return lista;
      }

      /* Etiqueta roja con el código y los euros (pie), total dentro del botón y línea de PARIS5. */
      function actualizarDescuentos(c) {
        var codigos = codigosAplicados(c);
        if (el.codigos) {
          el.codigos.innerHTML = codigos.map(function (d) {
            return '<div class="fp-cart__codigo"><span class="fp-cart__codigo-etiqueta">' + ICONO_ETIQUETA + escapar(d.codigo) + '</span>' +
              (d.importe > 0 ? '<span class="fp-cart__codigo-importe">-' + formatear(d.importe) + '</span>' : '') + '</div>';
          }).join('');
          el.codigos.hidden = codigos.length === 0;
        }
        if (el.paris5) el.paris5.hidden = codigos.length > 0;
        if (el.total) el.total.textContent = c.item_count > 0 ? formatear(c.total_price) : '';
        actualizarCw(c, codigos.length > 0);
      }

      /* ---------- «10 % en tu primer pedido» dentro de la cesta (como en Sierra Darien) ----------
         Email -> lista de Klaviyo del popup (doble opt-in) -> se aplica el código a la cesta con /cart/update.js
         (igual que el descuento nativo de Horizon) -> aviso «aplicado» 5 s arriba + etiqueta con el código y los
         euros en el pie + total del botón ya rebajado. Se oculta si la cesta está vacía, si ya hay un código
         aplicado o si la clienta ya se suscribió en este navegador (popup o ficha de producto). */
      var cwConfirmando = false;
      var RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      function lsLeer(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
      function lsGuardar(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
      function cwSuscrita() { return lsLeer('fp_promo_suscrita') === '1' || lsLeer('fp_pp_suscrita') === '1'; }

      function actualizarCw(c, hayCodigo) {
        if (!el.cw || cwConfirmando) return;
        el.cw.hidden = !c || c.item_count === 0 || hayCodigo || cwSuscrita();
      }

      function iniciarCw() {
        var cw = document.querySelector('[data-fp-cw]');
        if (!cw || cw.dataset.fpCwListo) return;
        cw.dataset.fpCwListo = '1';
        var form = cw.querySelector('[data-fp-cw-form]');
        var correo = cw.querySelector('[data-fp-cw-email]');
        var boton = cw.querySelector('[data-fp-cw-enviar]');
        var error = cw.querySelector('[data-fp-cw-error]');
        var desplegable = cw.querySelector('[data-fp-cw-desplegable]');
        if (!form || !correo || !boton || !error) return;
        var enviando = false;

        function pintarBoton() {
          var ok = RE_EMAIL.test(correo.value.trim()) && !enviando;
          boton.disabled = !ok;
          boton.classList.toggle('fp-cart-cw__aplicar--activo', ok);
        }
        function fallo(texto) {
          error.textContent = texto || cw.getAttribute('data-txt-error') || 'No hemos podido aplicar el descuento.';
          error.hidden = false;
        }

        correo.addEventListener('input', function () { error.hidden = true; pintarBoton(); });

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (enviando) return;
          var valor = correo.value.trim();
          if (!RE_EMAIL.test(valor)) { fallo(cw.getAttribute('data-txt-invalido')); return; }
          var codigo = cw.getAttribute('data-codigo') || 'PRIMERA10';
          var textoBoton = boton.textContent;
          var controlador = window.AbortController ? new AbortController() : null;
          var espera = setTimeout(function () { if (controlador) controlador.abort(); }, 15000);
          enviando = true;
          pintarBoton();
          boton.textContent = '...';
          error.hidden = true;
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cw.getAttribute('data-clave')), {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
            signal: controlador ? controlador.signal : undefined,
            body: JSON.stringify({ data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Florence Paris - Cesta 10% primer pedido',
                profile: { data: { type: 'profile', attributes: {
                  email: valor,
                  properties: { fp_formulario: 'cesta_10', fp_consentimiento_version: '2026-09-14' },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                } } }
              },
              relationships: { list: { data: { type: 'list', id: cw.getAttribute('data-lista') } } }
            } })
          }).then(function (r) {
            if (r.status !== 202) throw new Error('suscripcion');
            lsGuardar('fp_promo_suscrita', '1'); lsGuardar('fp_pp_suscrita', '1'); lsGuardar('fp_promo_email', valor);
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: codigo })
            }).then(function (r2) {
              if (!r2.ok) throw new Error('codigo');
              /* La respuesta de /cart/update.js puede traer el total con el envío estimado sumado y sin el importe
                 del código: se vuelve a leer /cart.js (lo mismo que usa el resto de la cesta). */
              return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r3) { return r3.json(); });
            }).then(function (c) {
              var aplicado = (c.discount_codes || []).some(function (d) {
                return d && d.applicable && String(d.code).toUpperCase() === String(codigo).toUpperCase();
              });
              if (!aplicado) throw new Error('codigo');
              cwConfirmando = true;
              cw.classList.add('fp-cart-cw--aplicado');
              estado = c;
              renderizar(c);
              setTimeout(function () {
                cw.classList.add('fp-cart-cw--desvaneciendo');
                setTimeout(function () {
                  cwConfirmando = false;
                  cw.hidden = true;
                  cw.classList.remove('fp-cart-cw--aplicado', 'fp-cart-cw--desvaneciendo');
                  if (desplegable) desplegable.open = false;
                  correo.value = '';
                  if (estado) actualizarCw(estado, codigosAplicados(estado).length > 0);
                }, 400);
              }, 5000);
            });
          }).catch(function (err) {
            fallo(err && err.message === 'codigo' ? cw.getAttribute('data-txt-codigo') : null);
          }).finally(function () {
            clearTimeout(espera);
            enviando = false;
            boton.textContent = textoBoton;
            pintarBoton();
          });
        });
      }

      function renderizar(c) {
        refrescarReferencias();
        var serviceBox = document.querySelector('[data-fp-service-box]');
        var serviceToggle = document.querySelector('[data-fp-service-toggle]');
        if (serviceToggle) {
          serviceToggle.checked = c.items.some(function (item) { return String(item.variant_id) === serviceToggle.dataset.variant; });
          serviceBox.hidden = c.item_count === 0;
        }
        el.contadores.forEach(function (n) { n.textContent = c.item_count; });
        if (!el.lista) return;

        /* FP 10/10/2026: el envío gratis lo decide la app de envío de la tienda con el subtotal del pago
           (después de descuentos por producto como PARIS5 y ANTES de códigos sobre el pedido como PRIMERA10
           o PRIVE10). Ese importe es items_subtotal_price. Comprobado en el pago: 204,84 € con PRIMERA10
           (total 184,36 €) = envío gratis; 204,84 € con PARIS5 (subtotal 195,12 €) = 6,99 €. */
        actualizarBarraEnvio(typeof c.items_subtotal_price === 'number' ? c.items_subtotal_price : c.total_price);
        actualizarDescuentos(c);

        if (c.item_count === 0) {
          el.lista.innerHTML = '';
          if (el.vacio) el.vacio.hidden = false;
          if (el.footer) el.footer.hidden = true;
          if (el.upsellCaja) el.upsellCaja.hidden = true;
          return;
        }

        if (el.vacio) el.vacio.hidden = true;
        if (el.footer) el.footer.hidden = false;

        Promise.all(c.items.map(obtenerCompareAt)).then(function (comparados) {
          el.lista.innerHTML = c.items.map(function (item, i) {
            // Keep Shopify line indexes; the service is represented by its switch.
            if (serviceToggle && String(item.variant_id) === serviceToggle.dataset.variant) return "";
            var linea = i + 1;
            var variante = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="fp-cart-item__variante">' + escapar(item.variant_title) + '</p>' : '';
            var compareAt = comparados[i];
            var hayRebaja = compareAt && compareAt > item.price;
            var preciosHtml = '<span class="fp-cart-item__precio-actual">' + formatear(item.price) + '</span>';
            if (hayRebaja) {
              var porcentaje = Math.round(((compareAt - item.price) / compareAt) * 100);
              preciosHtml += '<span class="fp-cart-item__precio-tachado">' + formatear(compareAt) + '</span>';
              preciosHtml += '<span class="fp-cart-item__descuento">-' + porcentaje + '%</span>';
            }
            var urlProducto = item.url || '#';
            var esServicio = item.handle === 'embalaje-protegido-seguimiento-y-envio-prioritario';
            return (
              '<div class="fp-cart-item">' +
              '<a href="' + urlProducto + '" class="fp-cart-item__imagen">' + (item.image ? '<img src="' + imagenPequena(item.image, 264) + '" alt="' + escapar(item.product_title) + '" loading="lazy">' : '') + '</a>' +
              '<div class="fp-cart-item__info">' +
              '<a href="' + urlProducto + '" class="fp-cart-item__enlace"><p class="fp-cart-item__titulo">' + escapar(item.product_title) + '</p></a>' + variante +
              '<div class="fp-cart-item__precios' + (hayRebaja ? '' : ' fp-cart-item__precios--normal') + '">' + preciosHtml + '</div>' +
              '<div class="fp-cart-item__acciones">' +
              '<div class="fp-cart-item__cantidad">' +
              '<button type="button" class="fp-cart-item__boton" data-fp-cart-menos data-linea="' + linea + '" aria-label="Quitar una unidad">' + ICONO_MENOS + '</button>' +
              '<span class="fp-cart-item__numero">' + item.quantity + '</span>' +
              (esServicio ? '' : '<button type="button" class="fp-cart-item__boton" data-fp-cart-mas data-linea="' + linea + '" aria-label="Añadir una unidad">' + ICONO_MAS + '</button>') +
              '</div>' +
              '<button type="button" class="fp-cart-item__eliminar" data-fp-cart-eliminar data-linea="' + linea + '">Eliminar</button>' +
              '</div></div></div>'
            );
          }).join('');

          el.lista.querySelectorAll('[data-fp-cart-menos]').forEach(function (b) { b.addEventListener('click', function () { cambiarPorDelta(parseInt(b.dataset.linea, 10), -1); }); });
          el.lista.querySelectorAll('[data-fp-cart-mas]').forEach(function (b) { b.addEventListener('click', function () { cambiarPorDelta(parseInt(b.dataset.linea, 10), 1); }); });
          el.lista.querySelectorAll('[data-fp-cart-eliminar]').forEach(function (b) { b.addEventListener('click', function () { cambiarCantidad(parseInt(b.dataset.linea, 10), 0); }); });
        });

        var ultimoItem = c.items[c.items.length - 1];
        if (ultimoItem && ultimoItem.product_id !== ultimoProductIdUpsell) {
          ultimoProductIdUpsell = ultimoItem.product_id;
          cargarUpsells(ultimoItem.product_id);
        } else if (!ultimoItem) {
          if (el.upsellCaja) el.upsellCaja.hidden = true;
        } else if (upsellsTodos) {
          pintarUpsells(filtrarUpsells(upsellsTodos));
        }
      }

      /* FP (25/09): "Tambien te encantara" no recomienda el producto de la pagina actual
         ni los productos que ya estan en la cesta. */
      var upsellsTodos = null;
      function filtrarUpsells(lista) {
        var enCesta = {};
        ((estado && estado.items) || []).forEach(function (i) { enCesta[String(i.product_id)] = true; });
        var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
        var handleActual = m ? decodeURIComponent(m[1]) : '';
        return (lista || []).filter(function (p) {
          return p && !enCesta[String(p.id)] && p.handle !== handleActual;
        });
      }

      function obtenerHandlesManual() {
        var nodo = document.getElementById('fp-cart-upsell-manual-data');
        if (!nodo) return [];
        try {
          var texto = JSON.parse(nodo.textContent || '""');
          return texto.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
        } catch (e) { return []; }
      }

      function pintarTarjetaUpsell(producto) {
        var variante = producto.variants && producto.variants[0];
        if (!variante) return '';
        var imagenUrl = producto.featured_image || (producto.images && producto.images[0]) || (variante.featured_image ? variante.featured_image.src : '');
        var preciosHtml = '<span class="fp-cart-upsell-item__precio-actual">' + formatear(variante.price) + '</span>';
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          preciosHtml += '<span class="fp-cart-upsell-item__precio-tachado">' + formatear(variante.compare_at_price) + '</span>';
        }
        return (
          '<div class="fp-cart-upsell-item">' +
          '<a href="' + producto.url + '" class="fp-cart-upsell-item__imagen">' + (imagenUrl ? '<img src="' + imagenPequena(imagenUrl, 260) + '" alt="' + escapar(producto.title) + '" loading="lazy">' : '') + '</a>' +
          '<p class="fp-cart-upsell-item__titulo">' + escapar(producto.title) + '</p>' +
          '<div class="fp-cart-upsell-item__precios">' + preciosHtml + '</div>' +
          '<button type="button" class="fp-cart-upsell-item__anadir" data-fp-upsell-anadir data-variant-id="' + variante.id + '">Añadir a la cesta</button>' +
          '</div>'
        );
      }

      function pintarUpsells(productos) {
        if (!el.upsellLista || !el.upsellCaja) return;
        if (!productos || !productos.length) { el.upsellCaja.hidden = true; return; }
        el.upsellLista.innerHTML = productos.map(pintarTarjetaUpsell).join('');
        el.upsellCaja.hidden = false;
        el.upsellLista.querySelectorAll('[data-fp-upsell-anadir]').forEach(function (boton) {
          boton.addEventListener('click', function () {
            boton.disabled = true;
            boton.textContent = 'Añadiendo...';
            fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: boton.dataset.variantId, quantity: 1 }) })
              .then(function (r) { return r.json(); })
              .then(function () { return cargar(); })
              .then(function () {
                boton.disabled = false;
                boton.textContent = 'Añadida';
                setTimeout(function () { boton.textContent = 'Añadir a la cesta'; }, 1500);
              });
          });
        });
      }

      function cargarUpsells(productoIdBase) {
        var handlesManual = obtenerHandlesManual();
        if (handlesManual.length) {
          Promise.all(handlesManual.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return (r.ok ? r.json() : null); }).catch(function () { return null; }); }))
            .then(function (productos) { upsellsTodos = productos.filter(Boolean); pintarUpsells(filtrarUpsells(upsellsTodos)); });
          return;
        }
        if (!productoIdBase) { if (el.upsellCaja) el.upsellCaja.hidden = true; return; }
        fetch('/recommendations/products.json?product_id=' + productoIdBase + '&limit=8&intent=related')
          .then(function (r) { return (r.ok ? r.json() : { products: [] }); })
          .then(function (data) { upsellsTodos = data.products || []; pintarUpsells(filtrarUpsells(upsellsTodos).slice(0, 6)); })
          .catch(function () { if (el.upsellCaja) el.upsellCaja.hidden = true; });
      }

      function cambiarPorDelta(linea, delta) {
        if (!estado) return;
        var item = estado.items[linea - 1];
        if (!item) return;
        if (item.handle === 'embalaje-protegido-seguimiento-y-envio-prioritario' && delta > 0) return;
        cambiarCantidad(linea, Math.max(0, item.quantity + delta));
      }

      function cambiarCantidad(linea, cantidad) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: linea, quantity: cantidad }) })
          .then(function (r) { return r.json(); })
          .then(function () { return cargar(); });
      }

      function interceptarAddToCart() {
        /* FP 10/10/2026: antes se miraba la cesta una sola vez, a los 800 ms del toque. Con datos móviles
           añadir tarda más: el producto entraba pero la cesta no se abría hasta el segundo toque (y entonces
           salían 2 unidades). Ahora se mira la cesta cada 0,4 s (hasta 12 s) y se abre en cuanto el
           producto ya está dentro. Si se pulsa otra vez, manda el último toque. */
        var intentoActual = 0;
        document.addEventListener('click', function (evento) {
          var boton = evento.target.closest ? evento.target.closest('.add-to-cart-button, [name="add"], button[type="submit"][form]') : null;
          if (!boton) return;
          var intento = ++intentoActual;
          var antes = estado ? estado.item_count : null;
          var limite = Date.now() + 12000;
          function comprobar() {
            if (intento !== intentoActual) return;
            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) {
                if (intento !== intentoActual) return;
                if (antes === null ? c.item_count > 0 : c.item_count > antes) { abrir(); return; }
                if (Date.now() < limite) setTimeout(comprobar, 400);
              })
              .catch(function () {
                if (intento === intentoActual && Date.now() < limite) setTimeout(comprobar, 800);
              });
          }
          setTimeout(comprobar, 300);
        }, true);
      }

      return { init: init, abrir: abrir, cerrar: cerrar, cargar: cargar };
    })();

    FPCart.init();

    /* ============ FP POPUP DE DESCUENTO DE BIENVENIDA (07/10/2026: tarjeta de rascar) ============
       Pasos: 1 rascar -> 2 email (Klaviyo, lista V2nSsG) -> 3 codigo + categoria complementaria.
       - Se abre a los 5 s o al primer scroll, una vez por sesion (sessionStorage 'fp_promo_popup_mostrado').
       - Si la clienta ya se suscribio en este navegador (localStorage 'fp_promo_suscrita' o 'fp_pp_suscrita'),
         no se abre solo y la pestana abre directamente el paso 3 (codigo).
       - La categoria elegida se guarda en Klaviyo (propiedad fp_interes) y lleva a esa coleccion. */
    var FPPromoPopup = (function () {
      var CLAVE_SESION = 'fp_promo_popup_mostrado';
      var CLAVE_SUSCRITA = 'fp_promo_suscrita';
      var CLAVE_EMAIL = 'fp_promo_email';
      var CLAVE_RASCADO = 'fp_promo_rascado';
      var enviando = false;
      var el = {};
      var rasca = null;

      function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
      function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
      function yaSuscrita() { return ls(CLAVE_SUSCRITA) === '1' || ls('fp_pp_suscrita') === '1'; }

      function refrescar() {
        el.popup = document.querySelector('[data-fp-promo-popup]');
        el.pestana = document.querySelector('[data-fp-promo-popup-reabrir]');
        el.pasos = document.querySelectorAll('[data-fp-promo-paso]');
        el.form = document.querySelector('[data-fp-promo-form]');
        el.reclamar = document.querySelector('[data-fp-promo-reclamar]');
        el.tarjeta = document.querySelector('[data-fp-rasca]');
        el.lienzo = document.querySelector('[data-fp-rasca-lienzo]');
      }

      function mostrarPaso(numero) {
        el.pasos.forEach(function (paso) {
          var esElNuevo = paso.getAttribute('data-fp-promo-paso') == numero;
          paso.classList.toggle('fp-promo-popup__paso--oculto', !esElNuevo);
          paso.classList.remove('fp-promo-popup__paso--entrando');
          if (esElNuevo) { void paso.offsetWidth; paso.classList.add('fp-promo-popup__paso--entrando'); }
        });
        if (numero == 1) prepararRasca();
        if (numero == 2) {
          var c = el.form && el.form.querySelector('[data-fp-promo-email]');
          if (c && window.matchMedia('(hover: hover)').matches) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) {} }, 350);
        }
        var panel = el.popup && el.popup.querySelector('.fp-promo-popup__panel');
        if (panel) panel.scrollTop = 0;
      }

      /* ---------- Tarjeta de rascar (canvas) ---------- */
      function revelar(animado) {
        if (!el.tarjeta) return;
        el.tarjeta.classList.add('fp-promo-popup__tarjeta--revelada');
        ss(CLAVE_RASCADO, '1');
        if (el.reclamar && el.reclamar.classList.contains('fp-promo-popup__boton--oculto')) {
          el.reclamar.classList.remove('fp-promo-popup__boton--oculto');
          if (animado) el.reclamar.classList.add('fp-promo-popup__boton--entra');
        }
        if (rasca) rasca.revelado = true;
      }

      function dibujarCubierta(cv) {
        var r = cv.getBoundingClientRect();
        if (!r.width || !r.height) return false;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var w = Math.round(r.width), h = Math.round(r.height);
        cv.width = w * dpr; cv.height = h * dpr;
        var ctx = cv.getContext('2d');
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var g = ctx.createLinearGradient(0, 0, w, h);
        g.addColorStop(0, '#c2a590'); g.addColorStop(0.55, '#b99b84'); g.addColorStop(1, '#a88a73');
        ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
        /* grano de papel */
        for (var i = 0; i < Math.round(w * h / 18); i++) {
          ctx.fillStyle = Math.random() < 0.5 ? 'rgba(255,255,255,0.07)' : 'rgba(60,40,25,0.07)';
          ctx.fillRect(Math.random() * w, Math.random() * h, 1, 1);
        }
        /* trazo de "rascado" decorativo */
        ctx.save();
        ctx.strokeStyle = 'rgba(95,70,52,0.28)'; ctx.lineWidth = Math.max(18, w * 0.055); ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.beginPath();
        var cx = w / 2, cy = h * 0.52, aw = w * 0.17, ah = h * 0.16;
        ctx.moveTo(cx - aw * 1.25, cy + ah * 0.6);
        ctx.lineTo(cx - aw * 0.55, cy - ah);
        ctx.lineTo(cx - aw * 0.25, cy + ah * 0.9);
        ctx.lineTo(cx + aw * 0.35, cy - ah * 0.8);
        ctx.lineTo(cx + aw * 0.55, cy + ah * 1.1);
        ctx.lineTo(cx + aw * 1.1, cy - ah * 0.6);
        ctx.stroke();
        ctx.restore();
        /* marco fino */
        ctx.strokeStyle = 'rgba(255,255,255,0.45)'; ctx.lineWidth = 1;
        ctx.strokeRect(10.5, 10.5, w - 21, h - 21);
        /* textos */
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        var marca = cv.getAttribute('data-marca') || '';
        var titulo = cv.getAttribute('data-rasca') || 'RASCA AQUÍ';
        var sub = cv.getAttribute('data-rasca-sub') || '';
        function espaciado(txt, px) { try { ctx.letterSpacing = px + 'px'; } catch (e) {} return txt; }
        ctx.font = '600 ' + Math.round(w * 0.028) + 'px Montserrat, sans-serif';
        espaciado(marca, w * 0.006);
        ctx.fillStyle = 'rgba(255,255,255,0.35)'; ctx.fillText(marca, w / 2 + 0.6, h * 0.12 + 0.8);
        ctx.fillStyle = 'rgba(90,64,46,0.35)'; ctx.fillText(marca, w / 2, h * 0.12);
        var fam = getComputedStyle(cv).getPropertyValue('--fp-font-accent') || '';
        var tamTit = Math.round(w * 0.088), famTit = (fam.trim() ? fam : '"Josefin Sans", Montserrat, sans-serif');
        espaciado(titulo, w * 0.006);
        do { ctx.font = '700 ' + tamTit + 'px ' + famTit; } while (ctx.measureText(titulo).width > w - 48 && --tamTit > 10);
        ctx.shadowColor = 'rgba(70,45,30,0.35)'; ctx.shadowBlur = 6; ctx.shadowOffsetY = 2;
        ctx.fillStyle = '#ffffff'; ctx.fillText(titulo, w / 2, h * 0.49);
        ctx.shadowColor = 'transparent';
        var tamSub = Math.round(w * 0.026);
        espaciado(sub, w * 0.006);
        do { ctx.font = '500 ' + tamSub + 'px Montserrat, sans-serif'; } while (ctx.measureText(sub).width > w - 48 && --tamSub > 7);
        ctx.fillStyle = 'rgba(255,255,255,0.92)'; ctx.fillText(sub, w / 2, h * 0.80);
        try { ctx.letterSpacing = '0px'; } catch (e) {}
        return true;
      }

      function prepararRasca() {
        if (!el.lienzo || !el.tarjeta) return;
        if (ss(CLAVE_RASCADO) === '1') { revelar(false); return; }
        el.tarjeta.classList.remove('fp-promo-popup__tarjeta--revelada');
        if (el.reclamar) el.reclamar.classList.add('fp-promo-popup__boton--oculto');
        var cv = el.lienzo;
        function pintar() {
          if (!dibujarCubierta(cv)) { if (++intentos < 80) setTimeout(pintar, 50); return; }
          rasca = { cv: cv, ctx: cv.getContext('2d'), revelado: false, ultimo: null, pasos: 0 };
        }
        var intentos = 0;
        pintar();
        /* Repinta cuando la fuente de marca termina de cargar (el texto de la tarjeta usa Josefin Sans). */
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (rasca && rasca.cv === cv && !rasca.revelado && rasca.pasos === 0) dibujarCubierta(cv); });
      }

      function puntoDe(e) {
        var r = rasca.cv.getBoundingClientRect();
        return { x: e.clientX - r.left, y: e.clientY - r.top, w: r.width };
      }
      function rascar(p) {
        var ctx = rasca.ctx;
        var dpr = rasca.cv.width / p.w;
        ctx.save();
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.globalCompositeOperation = 'destination-out';
        ctx.globalAlpha = 1; ctx.strokeStyle = '#000000'; ctx.shadowColor = 'transparent';
        ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = Math.max(36, p.w * 0.12);
        ctx.beginPath();
        var a = rasca.ultimo || p;
        ctx.moveTo(a.x, a.y); ctx.lineTo(p.x + 0.01, p.y + 0.01); ctx.stroke();
        ctx.restore();
        rasca.ultimo = p;
        if (++rasca.pasos % 6 === 0) comprobar();
      }
      function comprobar() {
        if (!rasca || rasca.revelado) return;
        var cv = rasca.cv, ctx = rasca.ctx;
        var datos = ctx.getImageData(0, 0, cv.width, cv.height).data;
        var total = 0, vacios = 0, salto = 4 * 24;
        for (var i = 3; i < datos.length; i += salto) { total++; if (datos[i] < 40) vacios++; }
        if (total && vacios / total >= 0.42) revelar(true);
      }

      function activarRasca() {
        if (!el.lienzo) return;
        var cv = el.lienzo;
        var activo = false;
        cv.addEventListener('pointerdown', function (e) {
          if (!rasca || rasca.revelado) return;
          activo = true; rasca.ultimo = null;
          try { cv.setPointerCapture(e.pointerId); } catch (x) {}
          rascar(puntoDe(e));
          e.preventDefault();
        });
        cv.addEventListener('pointermove', function (e) {
          if (!activo || !rasca || rasca.revelado) return;
          var eventos = (e.getCoalescedEvents && e.getCoalescedEvents()) || [];
          if (!eventos.length) eventos = [e];
          for (var i = 0; i < eventos.length; i++) rascar(puntoDe(eventos[i]));
          e.preventDefault();
        });
        function soltar() { if (!activo) return; activo = false; if (rasca) { rasca.ultimo = null; comprobar(); } }
        cv.addEventListener('pointerup', soltar);
        cv.addEventListener('pointercancel', soltar);
        cv.addEventListener('lostpointercapture', soltar);
        cv.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); revelar(true); if (el.reclamar) el.reclamar.focus(); }
        });
        var tRedim;
        window.addEventListener('resize', function () {
          clearTimeout(tRedim);
          tRedim = setTimeout(function () { if (rasca && !rasca.revelado && el.popup.classList.contains('fp-promo-popup--abierto')) { dibujarCubierta(cv); } }, 200);
        });
      }

      /* ---------- Abrir / cerrar ---------- */
      function abrir(paso) {
        refrescar();
        if (!el.popup) return;
        el.popup.classList.add('fp-promo-popup--abierto');
        el.popup.setAttribute('aria-hidden', 'false');
        if (el.pestana) el.pestana.hidden = true;
        document.documentElement.style.overflow = 'hidden';
        mostrarPaso(paso || (yaSuscrita() ? 3 : 1));
      }

      function cerrar() {
        refrescar();
        if (!el.popup) return;
        el.popup.classList.remove('fp-promo-popup--abierto');
        el.popup.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (el.pestana) el.pestana.hidden = false;
      }

      function guardarInteres(texto) {
        var correo = ls(CLAVE_EMAIL);
        if (!correo || !el.form) return;
        try {
          fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(el.form.dataset.klaviyoCompany), {
            method: 'POST', keepalive: true,
            headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
            body: JSON.stringify({ data: { type: 'profile', attributes: { email: correo, properties: { fp_interes: texto, fp_interes_origen: 'popup_rascar' } } } })
          }).catch(function () {});
        } catch (e) {}
      }

      function init() {
        refrescar();
        if (!el.popup) return;
        activarRasca();

        document.addEventListener('click', function (e) {
          if (!e.target.closest) return;
          if (e.target.closest('[data-fp-promo-popup-cerrar]') || e.target.closest('[data-fp-promo-popup-overlay]')) { cerrar(); return; }
          if (e.target.closest('[data-fp-promo-popup-reabrir]')) { abrir(); return; }
          if (e.target.closest('[data-fp-promo-reclamar]')) { mostrarPaso(2); return; }

          var cat = e.target.closest('[data-fp-promo-siguiente]');
          if (cat) guardarInteres(cat.getAttribute('data-fp-promo-interes') || cat.textContent.trim());

          var botonCopiar = e.target.closest('[data-fp-promo-copiar]');
          if (botonCopiar) {
            var codigo = botonCopiar.getAttribute('data-codigo');
            var span = botonCopiar.querySelector('[data-fp-promo-codigo-texto]') || botonCopiar.querySelector('span');
            var hecho = function () {
              if (!span) return;
              var original = codigo;
              span.textContent = (el.popup && el.popup.getAttribute('data-txt-copiado')) || 'Copiado';
              setTimeout(function () { span.textContent = original; }, 1500);
            };
            if (navigator.clipboard && navigator.clipboard.writeText && codigo) {
              navigator.clipboard.writeText(codigo).then(hecho, function () {});
            } else if (codigo) {
              try { var t = document.createElement('textarea'); t.value = codigo; document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove(); hecho(); } catch (x) {}
            }
          }
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && el.popup && el.popup.classList.contains('fp-promo-popup--abierto')) cerrar();
        });

        if (el.form) {
          el.form.addEventListener('submit', function (e) {
            e.preventDefault();
            if (enviando) return;
            var correo = el.form.querySelector('[data-fp-promo-email]');
            var error = el.form.querySelector('[data-fp-promo-error]');
            var boton = el.form.querySelector('button[type="submit"]');
            if (!correo) return;
            var valor = correo.value.trim();
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(valor)) {
              error.textContent = (el.popup && el.popup.getAttribute('data-txt-email-invalido')) || 'Introduce un email válido.';
              error.hidden = false; correo.focus(); return;
            }
            var textoBoton = boton.textContent;
            var controlador = window.AbortController ? new AbortController() : null;
            var espera = setTimeout(function () { if (controlador) controlador.abort(); }, 15000);
            enviando = true;
            boton.disabled = true;
            boton.textContent = (el.popup && el.popup.getAttribute('data-txt-enviando')) || 'Enviando...';
            error.hidden = true;
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(el.form.dataset.klaviyoCompany), {
              method: 'POST',
              headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
              signal: controlador ? controlador.signal : undefined,
              body: JSON.stringify({ data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Florence Paris - Popup tarjeta de rascar',
                  profile: { data: { type: 'profile', attributes: {
                    email: valor,
                    properties: { fp_formulario: 'popup_rascar', fp_consentimiento_version: '2026-09-14' },
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  } } }
                },
                relationships: { list: { data: { type: 'list', id: el.form.dataset.klaviyoList } } }
              } })
            }).then(function (respuesta) {
              if (respuesta.status !== 202) throw new Error('subscription_failed');
              ls(CLAVE_SUSCRITA, '1'); ls('fp_pp_suscrita', '1'); ls(CLAVE_EMAIL, valor);
              mostrarPaso(3);
            }).catch(function () {
              error.textContent = (el.popup && el.popup.getAttribute('data-txt-error')) || 'No hemos podido procesar tu solicitud. Espera un momento y vuelve a intentarlo.';
              error.hidden = false;
            }).finally(function () {
              clearTimeout(espera);
              enviando = false;
              boton.disabled = false;
              boton.textContent = textoBoton;
            });
          });
        }

        var yaMostrado = ss(CLAVE_SESION) === '1';
        if (yaMostrado || yaSuscrita()) {
          if (el.pestana) el.pestana.hidden = false;
          return;
        }

        var disparado = false;
        function disparar() {
          if (disparado) return;
          disparado = true;
          ss(CLAVE_SESION, '1');
          abrir();
        }

        var temporizador = setTimeout(disparar, 5000);
        window.addEventListener('scroll', function fpPrimerScroll() {
          window.removeEventListener('scroll', fpPrimerScroll);
          clearTimeout(temporizador);
          disparar();
        }, { passive: true, once: true });
      }

      return { init: init, abrir: abrir, cerrar: cerrar };
    })();

    FPPromoPopup.init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-hero-desktop-h"]) return;
  try {
    
  (function () {
    function cfg() { return window.fpHeroMovil || { heroId: 'hero_jVaWmY', carrusel: false, enlaces: ['/collections/rebajas-de-verano'] }; }

    function inyectarBotonHero() {
      var c = cfg();
      var hero = document.querySelector('[id*="' + c.heroId + '"]');
      if (!hero) return;
      if (hero.querySelector('.fp-hero-boton')) return;
      var a = document.createElement('a');
      a.className = 'fp-hero-boton';
      a.href = c.enlaces[0];
      a.textContent = 'Comprar ahora';
      hero.appendChild(a);
    }

    /* ---------- Carrusel movil (efecto slideshow de Sierra Darien) ---------- */
    var EASE_SALIDA = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
    var EASE_ENTRADA = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    var mq = window.matchMedia('(max-width: 749px)');
    var estado = null;

    function montar() {
      var c = cfg();
      if (!c.carrusel || estado || !mq.matches) return;
      var hero = document.querySelector('[id*="' + c.heroId + '"]');
      var tpl = document.querySelector('[data-fp-hm-plantilla]');
      if (!hero || !tpl) return;
      var grid = hero.querySelector('.hero__media-grid');
      var pic = grid && grid.querySelector('picture.hero__media');
      if (!grid || !pic) return;

      var s1 = document.createElement('div');
      s1.className = 'fp-hm-slide is-selected';
      pic.parentNode.insertBefore(s1, pic);
      s1.appendChild(pic);

      var s2 = document.createElement('div');
      s2.className = 'fp-hm-slide';
      s2.setAttribute('aria-hidden', 'true');
      s2.appendChild(tpl.content.cloneNode(true));
      s1.parentNode.insertBefore(s2, s1.nextSibling);
      var img2 = s2.querySelector('img');
      if (img2) { img2.loading = 'eager'; img2.decoding = 'async'; }

      var seg = parseFloat(c.segundos) || 3;
      var nav = document.createElement('div');
      nav.className = 'fp-hm-dots';
      nav.style.setProperty('--fp-hm-dur', seg + 's');
      [s1, s2].forEach(function (sl, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fp-hm-dot';
        b.setAttribute('aria-label', 'Ir a la imagen ' + (i + 1));
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        b.innerHTML = '<svg viewBox="0 0 8 8" aria-hidden="true" focusable="false">' +
          '<circle cx="4" cy="4" r="3.25" fill="none" stroke="currentColor" stroke-width="1.5" stroke-opacity="0.2"></circle>' +
          '<circle cx="4" cy="4" r="3.25" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></circle></svg>';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!estado || i === estado.indice) return;
          ir(i - estado.indice, true);
        });
        nav.appendChild(b);
      });
      hero.appendChild(nav);

      estado = { hero: hero, grid: grid, slides: [s1, s2], indice: 0, timer: null, ocupado: false, pic: pic, nav: nav };
      programar();

      var x0 = null, y0 = null;
      grid.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      grid.addEventListener('touchend', function (e) {
        if (x0 === null || !estado) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) ir(dx < 0 ? 1 : -1, true);
      }, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (!estado) return;
        if (document.hidden) { clearTimeout(estado.timer); } else { reiniciarContador(); programar(); }
      });
    }

    function desmontar() {
      if (!estado) return;
      clearTimeout(estado.timer);
      var s1 = estado.slides[0], s2 = estado.slides[1];
      s1.getAnimations().concat(s2.getAnimations()).forEach(function (a) { a.cancel(); });
      s1.parentNode.insertBefore(estado.pic, s1);
      s1.remove(); s2.remove();
      if (estado.nav) estado.nav.remove();
      var b = estado.hero.querySelector('.fp-hero-boton');
      if (b) b.href = cfg().enlaces[0];
      estado = null;
    }

    function marcarPunto(i) {
      if (!estado || !estado.nav) return;
      Array.prototype.forEach.call(estado.nav.children, function (b, k) {
        b.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }

    /* Vuelve a empezar el circulo del punto activo (misma duracion que el temporizador) */
    function reiniciarContador() {
      if (!estado || !estado.nav) return;
      var b = estado.nav.children[estado.indice];
      if (!b) return;
      b.setAttribute('aria-current', 'false');
      void b.offsetWidth;
      b.setAttribute('aria-current', 'true');
    }

    function programar() {
      if (!estado) return;
      clearTimeout(estado.timer);
      var seg = parseFloat(cfg().segundos) || 3;
      estado.timer = setTimeout(function () { ir(1, false); }, seg * 1000);
    }

    function ir(paso, manual) {
      if (!estado) return;
      if (estado.ocupado) { if (!manual) { clearTimeout(estado.timer); estado.timer = setTimeout(function () { ir(paso, false); }, 300); } return; }
      var n = estado.slides.length;
      var desde = estado.slides[estado.indice];
      var nuevo = (estado.indice + paso + n) % n;
      var hacia = estado.slides[nuevo];
      estado.ocupado = true;
      clearTimeout(estado.timer);

      /* Los tiempos van con setTimeout (y no con animation.finished) para que el carrusel no se
         quede parado si el navegador congela los fotogramas, p. ej. con la pestana en segundo plano. */
      var salida = desde.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: EASE_SALIDA, fill: 'both' });
      setTimeout(function () {
        if (!estado) return;
        desde.classList.remove('is-selected');
        desde.setAttribute('aria-hidden', 'true');
        hacia.classList.add('is-selected');
        hacia.removeAttribute('aria-hidden');
        salida.cancel();
        estado.indice = nuevo;
        marcarPunto(nuevo);
        programar();
        var b = estado.hero.querySelector('.fp-hero-boton');
        if (b) b.href = cfg().enlaces[nuevo] || cfg().enlaces[0];
        var entrada = hacia.animate(
          [{ opacity: 0, transform: 'scale(1.2)' }, { opacity: 1, transform: 'scale(1)' }],
          { duration: 800, easing: EASE_ENTRADA, fill: 'both' }
        );
        setTimeout(function () {
          entrada.cancel();
          if (!estado) return;
          estado.ocupado = false;
        }, 820);
      }, 210);
    }

    /* ---------- Hero a pantalla completa bajo el menu ---------- */
    var pcAncho = 0, pcHero = null, pcHeader = null, pcPendiente = false;
    function pcMedir(forzar) {
      var c = cfg();
      if (!c.pantallaCompleta) return;
      pcHero = pcHero || document.querySelector('.shopify-section[id*="' + c.heroId + '"]') || document.querySelector('[id*="' + c.heroId + '"]');
      pcHeader = pcHeader || document.querySelector('[data-fp-header]');
      if (!pcHero) return;
      var sp = document.querySelector('.fp-header__spacer');
      var an = document.querySelector('.fp-announcement');
      pcHero.style.setProperty('--fp-hc-sp', (sp ? sp.offsetHeight : 0) + 'px');
      /* El alto solo se recalcula si cambia el ancho (en movil la barra del navegador cambia el alto al hacer scroll) */
      if (forzar || window.innerWidth !== pcAncho) {
        pcAncho = window.innerWidth;
        pcHero.style.setProperty('--fp-hc-alto', Math.max(300, window.innerHeight - (an ? an.offsetHeight : 0)) + 'px');
      }
      pcColor();
    }
    function pcColor() {
      if (!pcHero || !pcHeader) return;
      var sobre = pcHero.getBoundingClientRect().bottom > pcHeader.getBoundingClientRect().bottom + 1;
      pcHeader.classList.toggle('fp-header--sobre-hero', sobre);
    }
    function pcScroll() { pcColor(); }

    function iniciar() {
      inyectarBotonHero();
      montar();
      pcMedir(true);
    }
    window.addEventListener('resize', function () { pcMedir(false); });
    window.addEventListener('scroll', pcScroll, { passive: true });
    document.addEventListener('scroll', pcScroll, { passive: true, capture: true });

    mq.addEventListener('change', function () { if (mq.matches) montar(); else desmontar(); });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    window.addEventListener('load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-parisienne-font"]) return;
  try {
    
  (function () {
    function initMobileMenuAccordions() {
      var submenus = document.querySelectorAll('.fp-mobile-menu__submenu');
      submenus.forEach(function (sm) {
        if (sm.dataset.fpAccInit === '1') return;
        sm.dataset.fpAccInit = '1';
        var kids = Array.from(sm.children);
        for (var i = 0; i < kids.length; i++) {
          var el = kids[i];
          if (el.classList && el.classList.contains('fp-mobile-menu__columna-titulo')) {
            var next = kids[i + 1];
            var tieneHijos = next && next.classList && next.classList.contains('fp-mobile-menu__lista') && next.children.length > 0;
            if (!tieneHijos) continue;
            var det = document.createElement('details'); det.className = 'fp-mm-acc';
            var sum = document.createElement('summary'); sum.className = 'fp-mm-acc__summary';
            sum.textContent = el.textContent;
            det.appendChild(sum);
            var content = document.createElement('div'); content.className = 'fp-mm-acc__content';
            content.appendChild(next);
            det.appendChild(content);
            el.replaceWith(det);
            kids = Array.from(sm.children);
            i = kids.indexOf(det);
          } else if (el.classList && el.classList.contains('fp-mobile-menu__columna-titulo-link')) {
            var nextL = kids[i + 1];
            if (nextL && nextL.classList && nextL.classList.contains('fp-mobile-menu__lista') && nextL.children.length === 0) {
              nextL.remove(); kids = Array.from(sm.children);
            }
          }
        }
      });
    }

    function fixCuentaLinks() {
      var selectores = [
        'a.fp-header__icon-btn[aria-label*="cuenta" i]',
        'a.fp-header__icon-btn[aria-label*="account" i]',
        'a.fp-mobile-menu__pie-cuenta'
      ];
      selectores.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (a) {
          if (a.dataset.fpAccountFixed === '1') return;
          a.setAttribute('href', '/account');
          a.setAttribute('target', '_top');
          a.setAttribute('rel', 'noopener');
          var clone = a.cloneNode(true);
          clone.dataset.fpAccountFixed = '1';
          if (a.parentNode) a.parentNode.replaceChild(clone, a);
        });
      });
    }

    function hookSubscripcion() {
      var form = document.querySelector('[data-fp-promo-form]');
      if (!form || form.dataset.fpSubHooked === '1') return;
      form.dataset.fpSubHooked = '1';
      form.addEventListener('submit', function () {
        try { localStorage.setItem('fp_popup_suscrito', '1'); } catch (e) {}
      }, true);
    }

    function programarPopupDiferido() {
      if (!window.__fp_promo_debe_abrir) return;
      if (window.__fp_promo_timer_set) return;
      window.__fp_promo_timer_set = true;
      setTimeout(function () {
        try { localStorage.setItem('fp_popup_ultima_vista', String(Date.now())); } catch (e) {}
        var pestana = document.querySelector('.fp-promo-popup__pestana');
        if (pestana) pestana.click();
      }, 11000);
    }

    /* FP (09/10): el popup solo se cierra con la X. Se bloquea cerrar
       pulsando fuera (fondo oscuro) y con la tecla Escape. */
    function soloCierraConX() {
      if (window.__fpPopupSoloX) return;
      window.__fpPopupSoloX = true;
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && (t.closest('[data-fp-promo-popup-overlay]') || t.closest('.fp-promo-popup__no'))) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }, true);
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var p = document.querySelector('.fp-promo-popup--abierto');
        if (p) e.stopImmediatePropagation();
      }, true);
    }

    function init() {
      soloCierraConX();
      initMobileMenuAccordions();
      fixCuentaLinks();
      hookSubscripcion();
      programarPopupDiferido();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    setTimeout(init, 400);
    setTimeout(init, 1200);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'fp_visto_recientemente';
    var MAX_ITEMS = 12;
    var cacheProductoJS = {};

    /* FP 10/10/2026: la tienda pasó el formato de precio de «€162,95» a «162,95 €». Los productos guardados
       antes en este navegador traen el formato viejo: se convierten al leerlos y se guardan ya convertidos. */
    function normalizarPrecio(texto) {
      var m = /^\s*€\s*(.+?)\s*$/.exec(texto || '');
      return m ? m[1] + ' €' : (texto || '');
    }
    function leerAlmacenados() {
      try {
        var datos = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        if (!Array.isArray(datos)) return [];
        datos.forEach(function (p) { if (p && typeof p.price === 'string') p.price = normalizarPrecio(p.price); });
        return datos;
      } catch (e) { return []; }
    }
    function derivarHandle(p) {
      if (p && p.handle) return p.handle;
      var u = (p && p.url) || '';
      u = u.split('?')[0].split('#')[0].replace(/\/$/, '');
      var m = u.match(/\/products\/([^\/]+)/);
      return m ? m[1] : '';
    }
    function guardarProductoActual() {
      var nodo = document.querySelector('[data-fp-current-product]');
      if (!nodo) return;
      var actual = {
        id: nodo.getAttribute('data-id'), handle: nodo.getAttribute('data-handle') || '',
        title: nodo.getAttribute('data-title'), url: nodo.getAttribute('data-url'),
        price: nodo.getAttribute('data-price'),
        image1: nodo.getAttribute('data-image1'), image2: nodo.getAttribute('data-image2')
      };
      if (!actual.id || !actual.image1) return;
      var lista = leerAlmacenados().filter(function (p) { return p.id !== actual.id; });
      lista.unshift(actual);
      if (lista.length > MAX_ITEMS) lista = lista.slice(0, MAX_ITEMS);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(lista)); } catch (e) {}
    }
    function crearOverlays(handle) {
      var wrap = document.createElement('div');
      wrap.className = 'fp-card-overlays';
      wrap.setAttribute('data-fp-card-overlays', '');
      wrap.innerHTML =
        '<button type="button" class="fp-card-overlay fp-card-overlay--wish" data-fp-wish data-fp-handle="' + handle + '" aria-label="Añadir a favoritos">' +
          '<svg class="fp-card-overlay__ico" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">' +
            '<path class="fp-star-outline" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" d="M12 3.5l2.6 5.6 6.1.6-4.6 4.2 1.3 6-5.4-3.2-5.4 3.2 1.3-6L3.3 9.7l6.1-.6z"/>' +
            '<path class="fp-star-fill" fill="currentColor" d="M12 3.5l2.6 5.6 6.1.6-4.6 4.2 1.3 6-5.4-3.2-5.4 3.2 1.3-6L3.3 9.7l6.1-.6z" style="display:none"/>' +
          '</svg>' +
        '</button>' +
        '<button type="button" class="fp-card-overlay fp-card-overlay--qa" data-fp-recent-qa data-fp-handle="' + handle + '" aria-label="Compra rápida">' +
          '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" d="M12 5v14M5 12h14"/></svg>' +
        '</button>';
      return wrap;
    }
    function abrirQuickAddPorHandle(handle) {
      if (!handle) return;
      if (!window.FPQuickAdd || typeof window.FPQuickAdd.abrir !== 'function') { return; }
      var procesar = function (prod) {
        var img = (prod.featured_image || (prod.images && prod.images[0]) || '');
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var variantes = (prod.variants || []).map(function (v) {
          return { id: v.id, title: v.name || v.title, option1: v.option1, option2: v.option2, option3: v.option3, available: v.available !== false, price: v.price, compare_at_price: v.compare_at_price };
        });
        var options = (prod.options || []).map(function (o, i) {
          if (typeof o === 'string') return { name: o, position: i + 1 };
          return o;
        });
        var precioBase = prod.price != null ? prod.price : (variantes[0] && variantes[0].price);
        var comparaBase = prod.compare_at_price != null ? prod.compare_at_price : (variantes[0] && variantes[0].compare_at_price);
        window.FPQuickAdd.abrir({
          id: prod.id, handle: prod.handle, url: prod.url || ('/products/' + prod.handle),
          title: prod.title, editorial: '', image: img,
          price: precioBase, compare_at_price: comparaBase, options: options, variants: variantes
        });
      };
      if (cacheProductoJS[handle]) { procesar(cacheProductoJS[handle]); return; }
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (prod) { cacheProductoJS[handle] = prod; procesar(prod); })
        .catch(function (e) { console.error('[fp] fetch', e); });
    }
    document.addEventListener('click', function (ev) {
      var qa = ev.target.closest('[data-fp-recent-qa]');
      if (!qa) return;
      ev.preventDefault(); ev.stopPropagation();
      abrirQuickAddPorHandle(qa.getAttribute('data-fp-handle'));
    }, true);

    function renderizarCarrusel() {
      var seccion = document.querySelector('[data-fp-recent-section]');
      var track = document.querySelector('[data-fp-recent-track]');
      if (!seccion || !track) return;
      var actual = document.querySelector('[data-fp-current-product]');
      var idActual = actual ? actual.getAttribute('data-id') : null;
      var lista = leerAlmacenados().filter(function (p) { return p.id !== idActual; });
      if (lista.length === 0) { seccion.hidden = true; return; }
      track.innerHTML = '';
      lista.forEach(function (producto) {
        var handle = derivarHandle(producto);
        var item = document.createElement('a');
        item.className = 'fp-recent__item';
        item.href = producto.url;
        var imagenWrap = document.createElement('div');
        imagenWrap.className = 'fp-recent__imagen';
        var img1 = document.createElement('img');
        img1.className = 'fp-recent__img fp-recent__img--primera';
        img1.src = producto.image1;
        img1.alt = producto.title;
        img1.loading = 'lazy';
        imagenWrap.appendChild(img1);
        if (producto.image2) {
          var img2 = document.createElement('img');
          img2.className = 'fp-recent__img fp-recent__img--segunda';
          img2.src = producto.image2;
          img2.alt = producto.title;
          img2.loading = 'lazy';
          imagenWrap.appendChild(img2);
        }
        if (handle) { imagenWrap.appendChild(crearOverlays(handle)); }
        var nombre = document.createElement('p');
        nombre.className = 'fp-recent__nombre';
        nombre.textContent = producto.title;
        var precio = document.createElement('p');
        precio.className = 'fp-recent__precio';
        precio.textContent = producto.price;
        item.appendChild(imagenWrap);
        item.appendChild(nombre);
        item.appendChild(precio);
        track.appendChild(item);
      });
      seccion.hidden = false;
      if (typeof document.dispatchEvent === 'function') {
        document.dispatchEvent(new CustomEvent('fp:wishlist-cambiada'));
      }
      var prevBtn = document.querySelector('[data-fp-recent-prev]');
      var nextBtn = document.querySelector('[data-fp-recent-next]');
      var anchoScroll = function () {
        var primero = track.querySelector('.fp-recent__item');
        return primero ? primero.getBoundingClientRect().width + 20 : 300;
      };
      if (prevBtn) { prevBtn.addEventListener('click', function () { track.scrollBy({ left: -anchoScroll(), behavior: 'smooth' }); }); }
      if (nextBtn) { nextBtn.addEventListener('click', function () { track.scrollBy({ left: anchoScroll(), behavior: 'smooth' }); }); }
    }
    guardarProductoActual();
    renderizarCarrusel();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-reviews-pool"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = document.querySelector('[data-fpr-root]');
  if (!raiz) return;

  /* Modales al final del body para que queden por encima de cabecera y barra flotante */
  ['[data-fpr-modal]', '[data-fp-review-modal]'].forEach(function (sel) {
    var n = document.querySelector(sel);
    if (n && n.parentNode !== document.body) document.body.appendChild(n);
  });
  function bloquearScroll(si) {
    [document.documentElement, document.querySelector('.page-wrapper')].forEach(function (el) { if (el) el.style.overflow = si ? 'hidden' : ''; });
  }

  /* ================= LINEA RESUMEN BAJO EL PRECIO (solo en la ficha) ================= */
  (function lineaResumen() {
    var total = parseInt(raiz.getAttribute('data-total'), 10) || 0;
    if (!total) return;
    var precio = null;
    document.querySelectorAll('.fp-price').forEach(function (p) { if (!precio && p.closest('.product-details') && !p.closest('.fp-sticky-bar')) precio = p; });
    if (!precio || precio.parentNode.querySelector('.fpr-resumen')) return;
    var entera = parseInt(raiz.getAttribute('data-media-entera'), 10) || 0;
    var estrella = 'M12.00 1.70 L14.79 9.06 L22.65 9.44 L16.52 14.37 L18.58 21.96 L12.00 17.65 L5.42 21.96 L7.48 14.37 L1.35 9.44 L9.21 9.06Z';
    var estrellas = '';
    for (var k = 1; k <= 5; k++) {
      estrellas += '<svg class="fpr-resumen__estrella' + (k <= entera ? '' : ' fpr-resumen__estrella--vacia') + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + estrella + '"/></svg>';
    }
    var a = document.createElement('a');
    a.className = 'fpr-resumen';
    a.href = '#resenas';
    a.setAttribute('aria-label', 'Valoración media ' + raiz.getAttribute('data-media') + ' de 5. Ver las ' + total + ' reseñas');
    a.innerHTML = estrellas + '<span class="fpr-resumen__total">(' + total + ')</span>';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      raiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    precio.parentNode.insertBefore(a, precio);
  })();

  /* ================= LISTADO + PAGINACION ================= */
  var grid = raiz.querySelector('[data-fpr-grid]');
  var paginacion = raiz.querySelector('[data-fpr-paginacion]');
  var tarjetas = Array.prototype.slice.call(grid.querySelectorAll('[data-fpr-card]'));
  var mqMovil = window.matchMedia('(max-width: 749px)');
  var porPaginaDesktop = parseInt(raiz.getAttribute('data-por-pagina-desktop'), 10) || 14;
  var porPaginaMovil = parseInt(raiz.getAttribute('data-por-pagina-movil'), 10) || 7;
  var paginaActual = 1;

  function parsearFecha(s) {
    if (!s) return 0;
    var p = String(s).split('/');
    if (p.length !== 3) return 0;
    var d = parseInt(p[0], 10), m = parseInt(p[1], 10), y = parseInt(p[2], 10);
    if (!d || !m || !y) return 0;
    return new Date(y, m - 1, d).getTime();
  }

  if (raiz.getAttribute('data-orden') === 'aleatorio') {
    for (var i = tarjetas.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = tarjetas[i]; tarjetas[i] = tarjetas[j]; tarjetas[j] = tmp;
    }
  } else {
    tarjetas.sort(function (a, b) { return parsearFecha(b.getAttribute('data-fecha')) - parsearFecha(a.getAttribute('data-fecha')); });
  }
  tarjetas.forEach(function (t) { grid.appendChild(t); });

  function porPagina() { return mqMovil.matches ? porPaginaMovil : porPaginaDesktop; }
  function totalPaginas() { return Math.max(1, Math.ceil(tarjetas.length / porPagina())); }

  function revisarLeerMas(lista) {
    lista.forEach(function (t) {
      var texto = t.querySelector('[data-fpr-texto]');
      var mas = t.querySelector('[data-fpr-mas]');
      if (!texto || !mas) return;
      mas.hidden = !(texto.scrollHeight > texto.clientHeight + 2);
    });
  }

  function construirPaginacion() {
    var total = totalPaginas();
    if (tarjetas.length === 0 || total <= 1) { paginacion.hidden = true; paginacion.innerHTML = ''; return; }
    paginacion.hidden = false;
    var html = '<button type="button" class="fpr__pag-flecha" data-fpr-pag="prev" aria-label="Página anterior"' + (paginaActual === 1 ? ' disabled' : '') + '>&#8249;</button>';
    var paginas = [];
    for (var p = 1; p <= total; p++) {
      if (p === 1 || p === total || Math.abs(p - paginaActual) <= 1) paginas.push(p);
      else if (paginas[paginas.length - 1] !== '...') paginas.push('...');
    }
    paginas.forEach(function (p) {
      if (p === '...') html += '<span class="fpr__pag-puntos">…</span>';
      else html += '<button type="button" class="fpr__pag-num' + (p === paginaActual ? ' is-activa' : '') + '" data-fpr-pag="' + p + '"' + (p === paginaActual ? ' aria-current="page"' : '') + '>' + p + '</button>';
    });
    html += '<button type="button" class="fpr__pag-flecha" data-fpr-pag="next" aria-label="Página siguiente"' + (paginaActual === total ? ' disabled' : '') + '>&#8250;</button>';
    var desde = (paginaActual - 1) * porPagina() + 1;
    var hasta = Math.min(paginaActual * porPagina(), tarjetas.length);
    html += '<p class="fpr__pag-info">' + desde + '–' + hasta + ' de ' + tarjetas.length + ' reseñas</p>';
    paginacion.innerHTML = html;
  }

  function mostrarPagina(n, animar) {
    var total = totalPaginas();
    paginaActual = Math.min(Math.max(1, n), total);
    var ini = (paginaActual - 1) * porPagina();
    var fin = ini + porPagina();
    var visibles = [];
    tarjetas.forEach(function (t, idx) {
      var ver = idx >= ini && idx < fin;
      t.hidden = !ver;
      t.classList.remove('is-entrando');
      if (ver) visibles.push(t);
    });
    if (animar) {
      visibles.forEach(function (t, k) {
        t.style.animationDelay = (k * 45) + 'ms';
        void t.offsetWidth;
        t.classList.add('is-entrando');
      });
    }
    construirPaginacion();
    revisarLeerMas(visibles);
  }

  function irAPagina(n) {
    if (n === paginaActual) return;
    grid.classList.add('is-saliendo');
    setTimeout(function () {
      mostrarPagina(n, true);
      grid.classList.remove('is-saliendo');
      if (grid.getBoundingClientRect().top < 100 && grid.scrollIntoView) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 280);
  }

  paginacion.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fpr-pag]');
    if (!b || b.disabled) return;
    var v = b.getAttribute('data-fpr-pag');
    if (v === 'prev') irAPagina(paginaActual - 1);
    else if (v === 'next') irAPagina(paginaActual + 1);
    else irAPagina(parseInt(v, 10));
  });

  var modoAnterior = mqMovil.matches;
  function alCambiarModo() {
    if (mqMovil.matches === modoAnterior) return;
    modoAnterior = mqMovil.matches;
    mostrarPagina(1, false);
  }
  if (mqMovil.addEventListener) mqMovil.addEventListener('change', alCambiarModo);
  else if (mqMovil.addListener) mqMovil.addListener(alCambiarModo);

  mostrarPagina(1, false);
  window.addEventListener('load', function () { revisarLeerMas(tarjetas.filter(function (t) { return !t.hidden; })); });

  /* ================= DETALLE ================= */
  var modal = document.querySelector('[data-fpr-modal]');
  var modalCaja = modal ? modal.querySelector('.fpr-modal__caja') : null;
  var modalMedia = modal ? modal.querySelector('[data-fpr-modal-media]') : null;
  var modalImg = modal ? modal.querySelector('[data-fpr-modal-img]') : null;
  var modalPanel = modal ? modal.querySelector('[data-fpr-modal-panel]') : null;
  var modalThumbs = modal ? modal.querySelector('[data-fpr-modal-thumbs]') : null;
  var fotosModal = [];
  var idxModal = 0;

  function pintarFotoModal() {
    if (!fotosModal.length) return;
    modalImg.src = fotosModal[idxModal].full;
    Array.prototype.slice.call(modalThumbs.children).forEach(function (b, k) { b.classList.toggle('is-activa', k === idxModal); });
  }

  function abrirDetalle(tarjeta, fotoInicial) {
    if (!modal) return;
    fotosModal = Array.prototype.slice.call(tarjeta.querySelectorAll('[data-fpr-foto]')).map(function (f) {
      return { full: f.getAttribute('data-full'), thumb: f.getAttribute('data-thumb') || f.getAttribute('data-full') };
    });
    idxModal = 0;
    fotosModal.forEach(function (f, k) { if (fotoInicial && f.full === fotoInicial) idxModal = k; });
    modalPanel.innerHTML = '';
    var tpl = tarjeta.querySelector('template[data-fpr-detalle]');
    if (tpl) modalPanel.appendChild(tpl.content.cloneNode(true));
    modalThumbs.innerHTML = '';
    if (fotosModal.length > 1) {
      fotosModal.forEach(function (f, k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fpr-modal__mini';
        b.setAttribute('aria-label', 'Foto ' + (k + 1));
        b.innerHTML = '<img alt="" src="' + f.thumb + '">';
        b.addEventListener('click', function () { idxModal = k; pintarFotoModal(); });
        modalThumbs.appendChild(b);
      });
    }
    if (fotosModal.length) {
      modalMedia.hidden = false;
      modalCaja.classList.remove('fpr-modal__caja--sin-media');
      pintarFotoModal();
    } else {
      modalMedia.hidden = true;
      modalCaja.classList.add('fpr-modal__caja--sin-media');
    }
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modalCaja.scrollTop = 0;
    modalPanel.scrollTop = 0;
    bloquearScroll(true);
  }

  function cerrarDetalle() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    bloquearScroll(false);
  }

  function moverFoto(paso) {
    if (fotosModal.length < 2) return;
    idxModal = (idxModal + paso + fotosModal.length) % fotosModal.length;
    pintarFotoModal();
  }

  if (modal) {
    modal.querySelectorAll('[data-fpr-modal-cerrar]').forEach(function (b) { b.addEventListener('click', cerrarDetalle); });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') cerrarDetalle();
      else if (e.key === 'ArrowLeft') moverFoto(-1);
      else if (e.key === 'ArrowRight') moverFoto(1);
    });
    var toqueX = null;
    modalMedia.addEventListener('touchstart', function (e) { toqueX = e.touches[0].clientX; }, { passive: true });
    modalMedia.addEventListener('touchend', function (e) {
      if (toqueX === null) return;
      var dx = e.changedTouches[0].clientX - toqueX;
      toqueX = null;
      if (Math.abs(dx) > 40) moverFoto(dx < 0 ? 1 : -1);
    });
  }

  grid.addEventListener('click', function (e) {
    if (e.target.closest('a')) return;
    var tarjeta = e.target.closest('[data-fpr-card]');
    if (!tarjeta) return;
    var foto = e.target.closest('[data-fpr-foto]');
    e.preventDefault();
    abrirDetalle(tarjeta, foto ? foto.getAttribute('data-full') : null);
  });
  grid.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var tarjeta = e.target.closest('[data-fpr-card]');
    if (!tarjeta || e.target !== tarjeta) return;
    e.preventDefault();
    abrirDetalle(tarjeta, null);
  });

  /* ================= FORMULARIO ================= */
  var form = document.querySelector('[data-fp-review-modal]');
  var contacto = document.getElementById('fp-review-contact-form');
  if (!form) return;

  var appUrl = raiz.getAttribute('data-app') || '';
  var pasos = [1, 2, 3, 4];
  var posPaso = 0;
  var valoracion = 0;
  var fotos = [];
  var enviando = false;

  var estrellas = form.querySelectorAll('[data-fp-review-estrella]');
  var filaEstrellas = form.querySelector('[data-fp-review-estrellas]');
  var bSiguiente = form.querySelector('[data-fp-review-siguiente]');
  var bEnviar = form.querySelector('[data-fp-review-enviar]');
  var bAtras = form.querySelector('[data-fp-review-atras]');
  var pie = form.querySelector('[data-fp-review-pie]');
  var progreso = form.querySelector('[data-fp-review-progreso]');
  var error = form.querySelector('[data-fp-review-error]');
  var inputFotos = form.querySelector('[data-fp-review-fotos-input]');
  var previa = form.querySelector('[data-fp-review-fotos-previa]');

  /* ================= PRENDA QUE SE RESEÑA (buscador) ================= */
  var raizUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var prendaCaja = form.querySelector('[data-fpr-prenda]');
  var prendaElegida = form.querySelector('[data-fpr-prenda-elegida]');
  var prendaImg = form.querySelector('[data-fpr-prenda-img]');
  var prendaNombre = form.querySelector('[data-fpr-prenda-nombre]');
  var prendaBuscador = form.querySelector('[data-fpr-prenda-buscador]');
  var prendaInput = form.querySelector('[data-fpr-prenda-input]');
  var prendaLista = form.querySelector('[data-fpr-prenda-lista]');
  var selectTalla = form.querySelector('[data-fp-review-talla]');
  var TALLAS_GENERICAS = ['XS', 'S', 'M', 'L', 'XL', 'Única'];
  var prenda = null;          /* { id, titulo, handle, img, tallas[] } o { ninguna: true } */
  var catalogo = null;        /* lista de productos de la tienda (se carga al abrir el formulario) */
  var cargandoCatalogo = null;
  var resultados = [];
  var activo = -1;

  function prendaDeLaFicha() {
    var id = raiz.getAttribute('data-producto-id') || '';
    if (!id) return null;
    var t = raiz.getAttribute('data-producto-tallas') || '';
    return {
      id: id,
      titulo: raiz.getAttribute('data-producto-titulo') || '',
      handle: raiz.getAttribute('data-producto-handle') || '',
      img: raiz.getAttribute('data-producto-img') || '',
      tallas: t ? t.split('|') : []
    };
  }

  function normalizar(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function miniatura(src, ancho) {
    if (!src) return '';
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (ancho || 120);
  }

  function tallasDe(p) {
    var ops = p.options || [];
    for (var i = 0; i < ops.length; i++) {
      var n = normalizar(ops[i].name);
      if (n === 'talla' || n === 'size' || n === 'tamano' || n === 'tallas') return ops[i].values || [];
    }
    return [];
  }

  function cargarCatalogo() {
    if (catalogo) return Promise.resolve(catalogo);
    if (cargandoCatalogo) return cargandoCatalogo;
    var lista = [];
    function pagina(n) {
      return fetch(raizUrl + 'products.json?limit=250&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('catalogo'); return r.json(); })
        .then(function (j) {
          var ps = (j && j.products) || [];
          ps.forEach(function (p) {
            lista.push({
              id: String(p.id),
              titulo: p.title || '',
              handle: p.handle || '',
              img: p.images && p.images[0] ? miniatura(p.images[0].src, 120) : '',
              tallas: tallasDe(p),
              norm: normalizar(p.title)
            });
          });
          if (ps.length === 250 && n < 8) return pagina(n + 1);
          return lista;
        });
    }
    cargandoCatalogo = pagina(1).then(function (l) { catalogo = l; cargandoCatalogo = null; return l; })
      .catch(function () { cargandoCatalogo = null; return null; });
    return cargandoCatalogo;
  }

  /* Coincidencia: 0 empieza por lo escrito, 1 una palabra empieza por lo escrito,
     2 lo contiene, 3 contiene todas las palabras, 4 contiene las letras en orden (aunque no seguidas) */
  function puntuar(item, q) {
    var t = item.norm;
    var idx = t.indexOf(q);
    if (idx === 0) return { nivel: 0, pos: 0, marcas: rango(idx, q.length) };
    if (idx > 0) {
      var antes = t.charAt(idx - 1);
      return { nivel: /[\s\-\/(]/.test(antes) ? 1 : 2, pos: idx, marcas: rango(idx, q.length) };
    }
    var palabras = q.split(' ').filter(Boolean);
    if (palabras.length > 1) {
      var marcas = [], todas = true, primera = Infinity;
      palabras.forEach(function (w) {
        var k = t.indexOf(w);
        if (k < 0) { todas = false; return; }
        primera = Math.min(primera, k);
        marcas = marcas.concat(rango(k, w.length));
      });
      if (todas) return { nivel: 3, pos: primera, marcas: marcas };
    }
    var qs = q.replace(/ /g, ''), posiciones = [], j = 0;
    for (var i = 0; i < t.length && j < qs.length; i++) { if (t.charAt(i) === qs.charAt(j)) { posiciones.push(i); j++; } }
    if (j === qs.length && qs.length > 0) return { nivel: 4, pos: posiciones[0], marcas: posiciones };
    return null;
  }
  function rango(a, n) { var r = []; for (var i = 0; i < n; i++) r.push(a + i); return r; }

  /* El texto normalizado conserva las posiciones del original (solo quita tildes y une espacios);
     se marca en negrita letra a letra sobre el titulo original */
  function resaltar(titulo, marcas) {
    var limpio = String(titulo).replace(/\s+/g, ' ').trim();
    var set = {};
    marcas.forEach(function (m) { set[m] = true; });
    var html = '', dentro = false;
    for (var i = 0; i < limpio.length; i++) {
      var c = esc(limpio.charAt(i));
      if (set[i] && !dentro) { html += '<b>'; dentro = true; }
      if (!set[i] && dentro) { html += '</b>'; dentro = false; }
      html += c;
    }
    if (dentro) html += '</b>';
    return html;
  }

  function buscar(texto) {
    var q = normalizar(texto);
    if (!catalogo) return [];
    if (!q) return [];
    var r = [];
    catalogo.forEach(function (item) {
      var m = puntuar(item, q);
      if (m) r.push({ item: item, m: m });
    });
    r.sort(function (a, b) { return a.m.nivel - b.m.nivel || a.m.pos - b.m.pos || a.item.titulo.length - b.item.titulo.length; });
    return r.slice(0, 8);
  }

  function pintarLista() {
    var texto = prendaInput.value;
    var q = normalizar(texto);
    if (!q) { prendaLista.hidden = true; prendaInput.setAttribute('aria-expanded', 'false'); return; }
    var html = '';
    if (!catalogo) {
      html = '<li class="fpr-prenda__mensaje" role="option" aria-disabled="true">' + (cargandoCatalogo ? 'Cargando prendas…' : 'No se han podido cargar las prendas. Pulsa "No encuentro mi prenda".') + '</li>';
    } else if (!resultados.length) {
      html = '<li class="fpr-prenda__mensaje" role="option" aria-disabled="true">No encontramos ninguna prenda con «' + esc(texto.trim()) + '».</li>';
    } else {
      html = resultados.map(function (r, k) {
        var img = r.item.img ? '<img src="' + esc(r.item.img) + '" alt="" loading="lazy">' : '<span class="fpr-prenda__sin-img"></span>';
        return '<li class="fpr-prenda__opcion' + (k === activo ? ' is-activa' : '') + '" role="option" id="fpr-prenda-op-' + k + '" aria-selected="' + (k === activo) + '" data-fpr-prenda-op="' + k + '">' + img + '<span class="fpr-prenda__opcion-texto">' + resaltar(r.item.titulo, r.m.marcas) + '</span></li>';
      }).join('');
    }
    prendaLista.innerHTML = html;
    prendaLista.hidden = false;
    prendaInput.setAttribute('aria-expanded', 'true');
    if (activo >= 0) prendaInput.setAttribute('aria-activedescendant', 'fpr-prenda-op-' + activo);
    else prendaInput.removeAttribute('aria-activedescendant');
    var act = prendaLista.querySelector('.is-activa');
    if (act && act.scrollIntoView) act.scrollIntoView({ block: 'nearest' });
  }

  function actualizarBusqueda() {
    resultados = buscar(prendaInput.value);
    activo = resultados.length ? 0 : -1;
    pintarLista();
  }

  function rellenarTallas() {
    var lista = prenda && !prenda.ninguna && prenda.tallas && prenda.tallas.length ? prenda.tallas : (prenda && !prenda.ninguna && prenda.id ? ['Única'] : TALLAS_GENERICAS);
    /* "Talla Única" -> "Única" (el texto "Talla" ya aparece en la etiqueta y en la tarjeta) */
    lista = lista.map(function (t) { return String(t).replace(/^talla\s+/i, '').trim(); }).filter(Boolean);
    var actual = selectTalla.value;
    selectTalla.innerHTML = '<option value="">—</option>' + lista.map(function (t) { return '<option>' + esc(t) + '</option>'; }).join('');
    if (lista.indexOf(actual) >= 0) selectTalla.value = actual;
    if (lista.length === 1) selectTalla.value = lista[0];
  }

  function elegirPrenda(p) {
    prenda = p;
    var aviso = prendaCaja.querySelector('.fpr-prenda__aviso');
    if (aviso) aviso.remove();
    if (p && p.ninguna) {
      prendaElegida.classList.add('fpr-prenda__elegida--ninguna');
      prendaNombre.textContent = 'No encuentro mi prenda (la revisaremos nosotros)';
      prendaImg.hidden = true;
    } else {
      prendaElegida.classList.remove('fpr-prenda__elegida--ninguna');
      prendaNombre.textContent = p.titulo;
      if (p.img) { prendaImg.src = p.img; prendaImg.hidden = false; } else { prendaImg.hidden = true; }
    }
    prendaElegida.hidden = false;
    prendaBuscador.hidden = true;
    prendaLista.hidden = true;
    prendaInput.setAttribute('aria-expanded', 'false');
    rellenarTallas();
    comprobarSiguiente();
  }

  function abrirBuscador() {
    prendaElegida.hidden = true;
    prendaBuscador.hidden = false;
    prendaInput.value = '';
    resultados = [];
    activo = -1;
    prendaLista.hidden = true;
    cargarCatalogo().then(function () { if (!prendaBuscador.hidden) { if (prendaInput.value) actualizarBusqueda(); } });
    comprobarSiguiente();
    setTimeout(function () { try { prendaInput.focus({ preventScroll: true }); } catch (e) { prendaInput.focus(); } }, 30);
  }

  function prendaLista_elegir(k) {
    var r = resultados[k];
    if (r) elegirPrenda({ id: r.item.id, titulo: r.item.titulo, handle: r.item.handle, img: r.item.img, tallas: r.item.tallas });
  }

  function hayPrenda() { return !!(prenda && (prenda.ninguna || prenda.id)) && prendaBuscador.hidden; }

  form.querySelector('[data-fpr-prenda-cambiar]').addEventListener('click', function () { prenda = null; abrirBuscador(); });
  form.querySelector('[data-fpr-prenda-no]').addEventListener('click', function () { elegirPrenda({ ninguna: true }); });
  prendaInput.addEventListener('input', function () {
    if (!catalogo) { cargarCatalogo().then(function () { actualizarBusqueda(); }); pintarLista(); return; }
    actualizarBusqueda();
  });
  prendaInput.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!resultados.length) return;
      e.preventDefault();
      activo = e.key === 'ArrowDown' ? (activo + 1) % resultados.length : (activo - 1 + resultados.length) % resultados.length;
      pintarLista();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activo >= 0) prendaLista_elegir(activo);
    } else if (e.key === 'Escape') {
      if (!prendaLista.hidden) { e.stopPropagation(); prendaLista.hidden = true; prendaInput.setAttribute('aria-expanded', 'false'); }
      else if (prenda === null && prendaDeLaFicha()) { e.stopPropagation(); elegirPrenda(prendaDeLaFicha()); }
    }
  });
  prendaLista.addEventListener('mousedown', function (e) { e.preventDefault(); });
  prendaLista.addEventListener('click', function (e) {
    var op = e.target.closest('[data-fpr-prenda-op]');
    if (op) prendaLista_elegir(parseInt(op.getAttribute('data-fpr-prenda-op'), 10));
  });

  function comprobarSiguiente() {
    if (pasos[posPaso] === 1) bSiguiente.disabled = valoracion === 0 || !hayPrenda();
  }

  progreso.innerHTML = pasos.map(function (p, k) { return '<span class="fp-review-form__barra" data-fp-review-barra="' + (k + 1) + '"></span>'; }).join('');

  function mostrarError(msg) { error.textContent = msg; error.hidden = !msg; }

  function verPaso(numeroPaso) {
    form.querySelectorAll('[data-fp-review-paso]').forEach(function (p) {
      p.classList.toggle('fp-review-form__paso--oculto', parseInt(p.getAttribute('data-fp-review-paso'), 10) !== numeroPaso);
    });
  }

  function irPaso(pos) {
    posPaso = pos;
    verPaso(pasos[pos]);
    pie.hidden = false;
    progreso.querySelectorAll('[data-fp-review-barra]').forEach(function (b, k) { b.classList.toggle('fp-review-form__barra--activa', k <= pos); });
    var ultimo = pos === pasos.length - 1;
    bAtras.classList.toggle('fp-review-form__atras--visible', pos > 0);
    bEnviar.classList.toggle('fp-review-form__siguiente--oculto', !ultimo);
    bSiguiente.classList.toggle('fp-review-form__siguiente--oculto', ultimo);
    bSiguiente.disabled = pasos[pos] === 1 && (valoracion === 0 || !hayPrenda());
    textoSiguiente();
    mostrarError('');
  }

  function textoSiguiente() {
    bSiguiente.textContent = (pasos[posPaso] === 2 && fotos.length === 0) ? 'Omitir' : 'Siguiente';
  }

  function pintarEstrellas() {
    estrellas.forEach(function (b) {
      var v = parseInt(b.getAttribute('data-fp-review-estrella'), 10);
      b.classList.toggle('is-activa', v <= valoracion);
    });
    if (filaEstrellas) filaEstrellas.classList.toggle('is-sin-valorar', valoracion === 0);
    if (pasos[posPaso] === 1) bSiguiente.disabled = valoracion === 0 || !hayPrenda();
  }

  function limpiarFotos() {
    fotos.forEach(function (f) { if (f.url) URL.revokeObjectURL(f.url); });
    fotos = [];
    previa.innerHTML = '';
    if (bSiguiente) textoSiguiente();
  }

  /* Activa la verificacion anti-spam de Shopify (hCaptcha invisible) en el formulario oculto */
  function activarCaptcha() {
    if (!contacto) return;
    if (contacto.dataset.hcaptchaBound || contacto.dataset.recaptchaBound) return;
    var campo = contacto.querySelector('[data-fpr-c-body]');
    if (campo) campo.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function esperarCaptcha() {
    if (!contacto) return Promise.resolve();
    activarCaptcha();
    return new Promise(function (resolver) {
      var intentos = 0;
      (function comprobar() {
        if (contacto.dataset.hcaptchaBound || contacto.dataset.recaptchaBound || intentos > 80) return resolver();
        intentos++;
        setTimeout(comprobar, 100);
      })();
    });
  }

  function abrirForm() {
    activarCaptcha();
    valoracion = 0;
    enviando = false;
    limpiarFotos();
    form.querySelector('[data-fp-review-texto]').value = '';
    form.querySelectorAll('input[type="text"], input[type="email"]').forEach(function (i) { i.value = ''; });
    form.querySelector('[data-fp-review-talla]').value = '';
    var deFicha = prendaDeLaFicha();
    if (deFicha) elegirPrenda(deFicha); else { prenda = null; abrirBuscador(); }
    cargarCatalogo();
    bEnviar.disabled = false;
    bEnviar.textContent = 'Enviar';
    pintarEstrellas();
    irPaso(0);
    form.hidden = false;
    bloquearScroll(true);
  }

  function cerrarForm() {
    if (enviando) return;
    form.hidden = true;
    bloquearScroll(false);
  }

  document.querySelectorAll('[data-fp-review-abrir]').forEach(function (b) { b.addEventListener('click', abrirForm); });
  form.querySelectorAll('[data-fp-review-cerrar]').forEach(function (b) { b.addEventListener('click', cerrarForm); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !form.hidden) cerrarForm(); });

  estrellas.forEach(function (b) {
    b.addEventListener('click', function () {
      var v = parseInt(b.getAttribute('data-fp-review-estrella'), 10);
      valoracion = v === valoracion ? 0 : v;
      pintarEstrellas();
    });
  });

  bSiguiente.addEventListener('click', function () {
    if (pasos[posPaso] === 1 && valoracion === 0) return;
    if (pasos[posPaso] === 1 && !hayPrenda()) return;
    if (pasos[posPaso] === 3 && !form.querySelector('[data-fp-review-texto]').value.trim()) {
      form.querySelector('[data-fp-review-texto]').focus();
      return;
    }
    if (posPaso < pasos.length - 1) irPaso(posPaso + 1);
  });
  bAtras.addEventListener('click', function () { if (posPaso > 0) irPaso(posPaso - 1); });

  if (inputFotos) {
    inputFotos.addEventListener('change', function () {
      Array.prototype.slice.call(inputFotos.files || []).forEach(function (archivo) {
        if (fotos.length >= 4) return;
        if (!archivo.type || archivo.type.indexOf('image/') !== 0) return;
        if (archivo.size > 15 * 1024 * 1024) return;
        var url = URL.createObjectURL(archivo);
        fotos.push({ file: archivo, url: url });
        var img = document.createElement('img');
        img.src = url;
        img.alt = '';
        previa.appendChild(img);
      });
      inputFotos.value = '';
      textoSiguiente();
    });
  }

  function comprimir(archivo) {
    return new Promise(function (resolver) {
      var img = new Image();
      var url = URL.createObjectURL(archivo);
      img.onload = function () {
        var max = 1600;
        var escala = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
        var lienzo = document.createElement('canvas');
        lienzo.width = Math.round(img.naturalWidth * escala);
        lienzo.height = Math.round(img.naturalHeight * escala);
        lienzo.getContext('2d').drawImage(img, 0, 0, lienzo.width, lienzo.height);
        lienzo.toBlob(function (blob) { URL.revokeObjectURL(url); resolver(blob || archivo); }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolver(archivo); };
      img.src = url;
    });
  }

  /* Foto comprimida (JPEG, max 1600 px) en base64 para enviarla a la app de reseñas */
  function fotoBase64(archivo) {
    return comprimir(archivo).then(function (blob) {
      return new Promise(function (resolver) {
        var lector = new FileReader();
        lector.onload = function () { resolver(String(lector.result).split(',')[1] || null); };
        lector.onerror = function () { resolver(null); };
        lector.readAsDataURL(blob);
      });
    });
  }

  function volverAIntentar(msg) {
    enviando = false;
    bEnviar.disabled = false;
    bEnviar.textContent = 'Enviar';
    mostrarError(msg);
  }

  function rellenarContacto(datos) {
    function fijar(sel, val) { var n = contacto && contacto.querySelector(sel); if (n) n.value = val; }
    fijar('[data-fpr-c-nombre]', datos.nombreCompleto);
    fijar('[data-fpr-c-email]', datos.email);
    fijar('[data-fpr-c-producto]', datos.producto + ' — ' + datos.productoUrl);
    fijar('[data-fpr-c-valoracion]', datos.valoracion + ' / 5');
    fijar('[data-fpr-c-talla]', datos.talla || '—');
    fijar('[data-fpr-c-fotos]', datos.fotosTexto);
    fijar('[data-fpr-c-body]',
      'NUEVA RESEÑA PENDIENTE DE APROBACIÓN\n\n' +
      'Producto: ' + datos.producto + '\n' +
      'Enlace: ' + datos.productoUrl + '\n' +
      'Valoración: ' + datos.valoracion + ' / 5\n' +
      'Talla: ' + (datos.talla || '—') + '\n' +
      'Clienta: ' + datos.nombreCompleto + ' (' + datos.email + ')\n' +
      'Fecha: ' + datos.fecha + '\n\n' +
      'Texto de la reseña:\n' + datos.texto + '\n\n' +
      'Fotos: ' + datos.fotosTexto
    );
  }

  function mostrarGracias(nombre) {
    var span = form.querySelector('[data-fp-review-gracias-nombre]');
    if (span) span.textContent = nombre ? ', ' + nombre : '';
    verPaso(5);
    pie.hidden = true;
  }

  bEnviar.addEventListener('click', function () {
    if (enviando) return;
    var nombre = form.querySelector('[data-fp-review-nombre]').value.trim();
    var apellido = form.querySelector('[data-fp-review-apellido]').value.trim();
    var email = form.querySelector('[data-fp-review-email]').value.trim();
    var texto = form.querySelector('[data-fp-review-texto]').value.trim();
    var talla = form.querySelector('[data-fp-review-talla]').value;

    if (valoracion === 0) { mostrarError('Selecciona una valoración de 1 a 5 estrellas.'); return; }
    if (!prenda) { mostrarError('Indica qué prenda quieres valorar (paso 1).'); return; }
    if (!texto) { mostrarError('Escribe unas palabras sobre el producto.'); return; }
    if (!nombre) { mostrarError('Indica tu nombre.'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { mostrarError('Introduce un email válido.'); return; }
    mostrarError('');

    enviando = true;
    bEnviar.disabled = true;
    bEnviar.textContent = 'Enviando…';

    /* 1) App de reseñas (Google Apps Script): email con fotos + botones APROBAR / RECHAZAR */
    if (appUrl) {
      var trampa = form.querySelector('[data-fp-review-web]');
      Promise.all(fotos.map(function (f) { return fotoBase64(f.file); })).then(function (lista) {
        var datos = {
          nombre: nombre,
          apellido: apellido,
          email: email,
          texto: texto,
          talla: talla,
          valoracion: valoracion,
          productoId: prenda && !prenda.ninguna ? prenda.id : '',
          productoTitulo: prenda && !prenda.ninguna ? prenda.titulo : '',
          productoUrl: prenda && !prenda.ninguna && prenda.handle ? window.location.origin + raizUrl + 'products/' + prenda.handle : '',
          sinProducto: !!(prenda && prenda.ninguna),
          fotos: lista.filter(Boolean),
          web: trampa ? trampa.value : ''
        };
        /* text/plain: evita la peticion previa CORS que Apps Script no admite */
        return fetch(appUrl, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(datos) });
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (j && j.ok) {
          enviando = false;
          mostrarGracias(nombre);
        } else if (j && j.error === 'limite') {
          volverAIntentar('Ya has enviado varias reseñas en la última hora. Inténtalo más tarde.');
        } else {
          volverAIntentar('No se ha podido enviar la reseña. Revisa tus datos e inténtalo de nuevo.');
        }
      }).catch(function () {
        volverAIntentar('No se ha podido enviar. Revisa tu conexión e inténtalo de nuevo.');
      });
      return;
    }

    /* 2) Alternativa sin app: formulario de contacto de Shopify (sin fotos) */
    var hoy = new Date();
    var fecha = hoy.getDate() + '/' + (hoy.getMonth() + 1) + '/' + hoy.getFullYear();
    rellenarContacto({
      nombreCompleto: (nombre + ' ' + apellido).trim(),
      email: email,
      producto: prenda && !prenda.ninguna ? prenda.titulo : 'No indicada',
      productoUrl: prenda && !prenda.ninguna && prenda.handle ? window.location.origin + raizUrl + 'products/' + prenda.handle : window.location.href,
      valoracion: valoracion,
      talla: talla,
      texto: texto,
      fecha: fecha,
      fotosTexto: fotos.length ? 'La clienta añadió ' + fotos.length + ' foto(s); las fotos solo llegan con la app de reseñas activada.' : 'Sin fotos'
    });
    /* Envio nativo: Shopify exige su verificacion anti-spam (hCaptcha). Al volver, se muestra el "Gracias". */
    try { sessionStorage.setItem('fp_resena_enviada', nombre || ' '); } catch (e) {}
    esperarCaptcha().then(function () {
      if (!contacto) { volverAIntentar('No se ha podido enviar la reseña. Inténtalo de nuevo más tarde.'); return; }
      if (typeof contacto.requestSubmit === 'function') contacto.requestSubmit();
      else contacto.submit();
    });
  });

  /* Vuelta tras el envio (y el reto anti-spam de Shopify si aparece) */
  var nombreGuardado = null;
  try { nombreGuardado = sessionStorage.getItem('fp_resena_enviada'); } catch (e) {}
  if (nombreGuardado !== null) {
    var ok = document.querySelector('[data-fpr-contacto-ok]') || /contact_posted=true/.test(window.location.search);
    var fallo = document.querySelector('[data-fpr-contacto-error]');
    if (ok || fallo) {
      try { sessionStorage.removeItem('fp_resena_enviada'); } catch (e) {}
      form.hidden = false;
      bloquearScroll(true);
      if (ok) {
        mostrarGracias(nombreGuardado.trim());
        try { history.replaceState(null, '', window.location.pathname); } catch (e) {}
      } else {
        irPaso(pasos.length - 1);
        mostrarError('No se ha podido enviar la reseña. Revisa tus datos e inténtalo de nuevo.');
      }
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fp-wishlist"]) return;
  try {
    
  (function () {
    function esperarWishlist(intentos) {
      if (window.FPWishlist) {
        iniciar();
        return;
      }
      if (intentos > 40) return;
      setTimeout(function () { esperarWishlist(intentos + 1); }, 50);
    }

    function iniciar() {
      var grid = document.querySelector('[data-fp-wishlist-grid]');
      var vacio = document.querySelector('[data-fp-wishlist-vacio]');
      if (!grid) return;

      function escapar(texto) {
        var d = document.createElement('div');
        d.textContent = texto || '';
        return d.innerHTML;
      }

      function formatear(centimos) {
        return (centimos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20ac';
      }

      function pintarTarjeta(producto) {
        var variante = producto.variants && producto.variants[0];
        if (!variante) return '';
        var imagenUrl = producto.featured_image || (producto.images && producto.images[0]) || '';
        var precioHtml = '<span style="color:#e4002b;font-weight:600;">' + formatear(variante.price) + '</span>';
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioHtml += ' <span style="text-decoration:line-through;opacity:0.5;font-size:0.85em;">' + formatear(variante.compare_at_price) + '</span>';
        }
        return (
          '<div class="fp-wishlist-card">' +
          '<div class="fp-wishlist-card__imagen-wrap">' +
          '<a href="' + producto.url + '">' +
          (imagenUrl ? '<img class="fp-wishlist-card__imagen" src="' + imagenUrl.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_400x$1$2') + '" alt="' + escapar(producto.title) + '" loading="lazy">' : '<div class="fp-wishlist-card__imagen"></div>') +
          '</a>' +
          '<button type="button" class="fp-wishlist-card__quitar" data-fp-wishlist-quitar="' + producto.handle + '" aria-label="Quitar de la lista de deseos">&#10005;</button>' +
          '</div>' +
          '<a href="' + producto.url + '" style="text-decoration:none;color:inherit;">' +
          '<p class="fp-wishlist-card__titulo">' + escapar(producto.title) + '</p>' +
          '<p style="margin:4px 0 0 0;">' + precioHtml + '</p>' +
          '</a>' +
          '</div>'
        );
      }

      function render() {
        var handles = window.FPWishlist.getAll();
        if (!handles.length) {
          grid.innerHTML = '';
          if (vacio) vacio.hidden = false;
          return;
        }
        if (vacio) vacio.hidden = true;

        Promise.all(
          handles.map(function (h) {
            return fetch('/products/' + h + '.js')
              .then(function (r) { return (r.ok ? r.json() : null); })
              .catch(function () { return null; });
          })
        ).then(function (productos) {
          grid.innerHTML = productos.filter(Boolean).map(pintarTarjeta).join('');
          grid.querySelectorAll('[data-fp-wishlist-quitar]').forEach(function (boton) {
            boton.addEventListener('click', function (e) {
              e.preventDefault();
              window.FPWishlist.quitar(boton.dataset.fpWishlistQuitar);
              render();
            });
          });
        });
      }

      render();
      document.addEventListener('fp:wishlist-cambiada', render);
    }

    esperarWishlist(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (function () {
    if (!window.location.pathname.startsWith('/collections/')) return;
    if (window.location.pathname.indexOf('/collections/otono-invierno-26') === 0) return;
    if (window.Shopify && window.Shopify.designMode) return;

    function shuffleGrid() {
      var items = document.querySelectorAll('.product-grid__item');
      if (!items.length) return;
      var parent = items[0].parentNode;
      if (!parent) return;
      if (parent.dataset.fpShuffled === '1') return;
      if (!parent.closest('results-list')) return;

      parent.style.transition = 'opacity 100ms ease';
      parent.style.opacity = '0';

      var arr = Array.prototype.slice.call(parent.children).filter(function (el) {
        return el.classList && el.classList.contains('product-grid__item');
      });
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
      }
      var frag = document.createDocumentFragment();
      arr.forEach(function (el) { frag.appendChild(el); });
      parent.appendChild(frag);
      parent.dataset.fpShuffled = '1';

      requestAnimationFrame(function () {
        parent.style.opacity = '1';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', shuffleGrid, { once: true });
    } else {
      shuffleGrid();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    var modal = document.querySelector('[data-fp-zoom-modal]');

    if (modal) {
    var imagenVisor = modal.querySelector('[data-fp-zoom-imagen]');
    var botonCerrar = modal.querySelector('[data-fp-zoom-cerrar]');

    function fpObtenerUrlGrande(img) {
      var origen = img.currentSrc || img.getAttribute('src') || '';
      if (!origen) return origen;
      try {
        var url = new URL(origen, window.location.href);
        if (url.searchParams.has('width')) { url.searchParams.set('width', '1600'); }
        return url.toString();
      } catch (e) { return origen; }
    }

    function fpAbrirVisor(img) {
      if (!img) return;
      imagenVisor.src = fpObtenerUrlGrande(img);
      imagenVisor.alt = img.alt || '';
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function fpCerrarVisor() {
      modal.hidden = true;
      imagenVisor.src = '';
      document.documentElement.style.overflow = '';
    }

    botonCerrar.addEventListener('click', fpCerrarVisor);
    modal.addEventListener('click', function (evento) { if (evento.target === modal) fpCerrarVisor(); });
    document.addEventListener('keydown', function (evento) { if (evento.key === 'Escape' && !modal.hidden) fpCerrarVisor(); });

    function fpDesactivarZoomNativo() {
      var botones = document.querySelectorAll('button[aria-label^="Ampliar"]');
      botones.forEach(function (boton) {
        if (boton.dataset.fpZoomListo) return;
        boton.dataset.fpZoomListo = 'true';
        boton.removeAttribute('on:click');
        boton.removeAttribute('on:pointerenter');
        boton.addEventListener('click', function (evento) {
          evento.preventDefault();
          var contenedor = boton.closest('li') || boton.closest('slideshow-slide') || boton.parentElement;
          var imagen = contenedor ? contenedor.querySelector('img') : null;
          fpAbrirVisor(imagen);
        });
      });
    }

    fpDesactivarZoomNativo();
    var observadorZoom = new MutationObserver(function () { fpDesactivarZoomNativo(); });
    observadorZoom.observe(document.body, { childList: true, subtree: true });
    }

    function fpColocarFavorito() {
      var favorito = document.querySelector('.product-details [data-fp-favorito]');
      var boton = document.querySelector('.product-details .add-to-cart-button');
      if (!favorito || !boton || favorito.dataset.fpColocado) return;
      var contenedorBoton = boton.parentElement;
      if (!contenedorBoton) return;
      var fila = document.createElement('div');
      fila.setAttribute('data-fp-compra-fila', '');
      contenedorBoton.insertBefore(fila, boton);
      fila.appendChild(boton);
      fila.appendChild(favorito);
      favorito.dataset.fpColocado = 'true';
    }

    fpColocarFavorito();
    var observadorFavorito = new MutationObserver(function () { fpColocarFavorito(); });
    observadorFavorito.observe(document.body, { childList: true, subtree: true });

    function fpColocarSelectorColor() {
      var swatches = document.querySelector('[data-fp-color-swatches]');
      if (!swatches || swatches.dataset.fpColocado) return;
      var referencia = document.querySelector('.product-details variant-picker') || document.querySelector('.product-details .variant-picker');
      if (referencia) {
        referencia.insertAdjacentElement('afterend', swatches);
        swatches.hidden = false;
        swatches.dataset.fpColocado = 'true';
        return;
      }
      var boton = document.querySelector('.product-details .add-to-cart-button');
      if (!boton) return;
      var contenedorBoton = boton.closest('[data-fp-compra-fila]') || boton.parentElement;
      if (!contenedorBoton || !contenedorBoton.parentElement) return;
      contenedorBoton.parentElement.insertBefore(swatches, contenedorBoton);
      swatches.hidden = false;
      swatches.dataset.fpColocado = 'true';
    }

    fpColocarSelectorColor();
    var observadorColorSwatches = new MutationObserver(function () { fpColocarSelectorColor(); });
    observadorColorSwatches.observe(document.body, { childList: true, subtree: true });

    function fpEncontrarContenedorScroll() {
      var candidato = document.querySelector('.page-wrapper');
      if (candidato && candidato.scrollHeight > candidato.clientHeight) return candidato;
      return window;
    }

    function fpObtenerScrollActual(contenedor) { return contenedor === window ? window.scrollY : contenedor.scrollTop; }
    function fpFijarScroll(contenedor, valor) { if (contenedor === window) window.scrollTo(0, valor); else contenedor.scrollTop = valor; }

    function fpClicSinScroll(elemento, contenedor) {
      var posicion = fpObtenerScrollActual(contenedor);
      elemento.click();
      requestAnimationFrame(function () {
        fpFijarScroll(contenedor, posicion);
        requestAnimationFrame(function () { fpFijarScroll(contenedor, posicion); });
      });
      setTimeout(function () { fpFijarScroll(contenedor, posicion); }, 60);
      setTimeout(function () { fpFijarScroll(contenedor, posicion); }, 220);
    }

    function fpInicializarStickyBar() {
      var barra = document.querySelector('[data-fp-sticky-bar]');
      var botonPrincipal = document.querySelector('.product-details .add-to-cart-button');
      var botonBarra = document.querySelector('[data-fp-sticky-bar-anadir]');
      if (!barra || barra.dataset.fpStickyListo) return;
      if (!botonPrincipal) return;

      var contenedorScroll = fpEncontrarContenedorScroll();
      barra.dataset.fpStickyListo = 'true';

      var fpContenedorEspacio = document.querySelector('.page-wrapper') || document.body;

      function fpAjustarEspacioInferior(visible) {
        if (visible) {
          var altura = barra.offsetHeight;
          fpContenedorEspacio.style.paddingBottom = altura + 'px';
        } else {
          fpContenedorEspacio.style.paddingBottom = '';
        }
      }

      function fpMostrarBarra(visible) {
        barra.classList.toggle('fp-sticky-bar--visible', visible);
        barra.setAttribute('aria-hidden', visible ? 'false' : 'true');
        fpAjustarEspacioInferior(visible);
      }

      window.addEventListener('resize', function () {
        if (barra.classList.contains('fp-sticky-bar--visible')) {
          fpAjustarEspacioInferior(true);
        }
      });

      var fpObservadorBotonPrincipal = new IntersectionObserver(function (entradas) {
        var entrada = entradas[0];
        var yaPaso = entrada.boundingClientRect.top < 0;
        fpMostrarBarra(!entrada.isIntersecting && yaPaso);
      }, { root: null, threshold: 0 });
      fpObservadorBotonPrincipal.observe(botonPrincipal);

      if (botonBarra && botonPrincipal) { botonBarra.addEventListener('click', function () { botonPrincipal.click(); }); }

      var raizTalla = barra.querySelector('[data-fp-sticky-bar-talla-raiz]');
      if (raizTalla) {
        var toggle = raizTalla.querySelector('[data-fp-sticky-bar-talla-toggle]');
        var lista = raizTalla.querySelector('[data-fp-sticky-bar-talla-lista]');
        var etiquetaActual = raizTalla.querySelector('[data-fp-sticky-bar-talla-actual]');
        var opciones = raizTalla.querySelectorAll('[data-fp-sticky-bar-talla]');

        function cerrarLista() { lista.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
        function abrirLista() { lista.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
        toggle.addEventListener('click', function (e) { e.stopPropagation(); if (lista.hidden) abrirLista(); else cerrarLista(); });
        document.addEventListener('click', function (e) { if (!raizTalla.contains(e.target)) cerrarLista(); });

        opciones.forEach(function (opcion) {
          opcion.addEventListener('click', function () {
            var valor = opcion.dataset.fpStickyBarTalla;
            var botonesNativos = document.querySelectorAll('.product-details .variant-option__button-label__text');
            for (var i = 0; i < botonesNativos.length; i++) {
              if (botonesNativos[i].textContent.trim() === valor) {
                var botonNativo = botonesNativos[i].closest('button, label');
                if (botonNativo) fpClicSinScroll(botonNativo, contenedorScroll);
                break;
              }
            }
            etiquetaActual.textContent = valor;
            opciones.forEach(function (o) { o.classList.toggle('fp-sticky-bar__talla-opcion--activa', o === opcion); });
            cerrarLista();
          });
        });

        document.addEventListener('fp:variante-cambiada', function () {
          var seleccionActual = document.querySelector('.product-details [aria-checked="true"] .variant-option__button-label__text, .product-details input:checked + label .variant-option__button-label__text');
          if (!seleccionActual) return;
          var textoActual = seleccionActual.textContent.trim();
          etiquetaActual.textContent = textoActual;
          opciones.forEach(function (o) { o.classList.toggle('fp-sticky-bar__talla-opcion--activa', o.dataset.fpStickyBarTalla === textoActual); });
        });
      }
    }

    fpInicializarStickyBar();
    var observadorSticky = new MutationObserver(function () { fpInicializarStickyBar(); });
    observadorSticky.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
